import moment from "moment";
import {
  locSto,
  /*locRem,*/ locPremiA,
  locpermiCuCo,
  locPremiScr,
  locRept,
} from "./Locstor";

const locRem = JSON.parse(window.localStorage.getItem("DataRem")) || {};

console.log("============================================");
console.log(locRem.idi);
// alert(locRem.idi+ ' in iD')
console.log("============================================");

const insh = {
  tbname: {
    More: {},
    other: {},
    Currencies: [],
    Units: [],
    AutoCurrUnits: [],
    CurrenciesToInv: [],
    countCurrBySafe: [],
    CurrenciesFav: [],
    Users: [],
    Permissions: {},
    groups: [],
    groupsSub: [],
    FavGroup: [],
    permiCurr: {},
    permis: {},
    SettInvsApp: {},
    PermissionApp: {},
    omlats: [],
    //   tot:{totSal:0,totAjel:0,totNetAndBank:0,totNetAmount:0,},
    tot: {},
    trans: [],
    SalesDetails: [],
    AccountBalance: [],

    types: [],
    Safes: [],
    Stocks: [],
    Customers: [],
    salesmen: [],
    costcenters: [],
    center: [],
    Branches: [],
    Banks: [],
    Employees: [],
    Acts: [],
    Areas: [],
    Cities: [],
    Countries: [],
    ListUsers: [],
    items: [],
    Accindex: [],
    tax_groups: [],
    Managements: [],
    //  Foundations:[],Foundation_pointss:[],tax_groupss:[],omlats:[],
    // costcenter:[],Departments:[],jobs:[],CardTypes:[],
    resData: [],

    typesFltr: [],
    SafesFltr: [],
    StocksFltr: [],

    //autos
    Management: {},
    autos: [{ id: -1, name: "" }],
  },
  autos: {
    payment: [
      { id: "1", name: "نقدي" },
      { id: "2", name: "شيك" },
      { id: "3", name: "تحويل" },
    ],
    CheckStatus: [
      { id: "1", name: "معتمد" },
      { id: "2", name: "ملغي" },
    ],
  },
  prevents: true,
  var: { custmtype: 1, typeInv: 0 },

  indx: {
    Types: 0,
    TypesFltr: 0,
    Safes: 0,
    Customers: 0,
    Salesmens: 0,
    Stocks: 0,
    bank: 0,
    Units: 0,
    Costcenters: 0,
  },

  optionPricePay: [
    { id: 0, name: "تجزئة" },
    { id: 1, name: "موزع" },
    { id: 2, name: "جملة" },
  ],

  stateChang: {
    taxperc: null,
    pricePay: true,
  },

  InfoSub: {
    id: "",
    hdshw: false,
    Price: "",
    PricePu: 0,
    val1: "",
    barcode: "",
    symbol: "",
    perc: 1,
    taxperc: "",
    taxval: "",
    is_tab3_curr: 0,
    DiscPers: "",
    discount: "",
    totJust: "",
    unitame: "",
    minPrice: 0,
    dPrice: 0,
    jPrice: 0,
    salePrice: 0,
    no: "",
    Qtys: 0,
    notes: ""
  },

  PermissionApp: locPremiA,

  Foundation: {
    id: "",
    nameA: "",
    nameE: "",
    FieldA: "",
    FieldE: "",
    bsn_no: "",
    licence_no: "",
    Address: "",
    Tel: "",
    Mobile: "",
    Fax: "",
    Email: "",
    website: "",
    Logo: "",
    Exchangeval: "",
    tax: "",
    port: "",
    tax_no: "",
    BillNotes: "",
    BillNotes1: "",
    BillNotes2: "",
    BillNotes3: "",
    Disc1_header_ar: "",
    Disc2_header_ar: "",
    Disc3_header_ar: "",
    Disc4_header_ar: "",
    Disc1_header_en: "",
    Disc2_header_en: "",
    Disc3_header_en: "",
    Disc4_header_en: "",
    Disc1_footer_ar: "",
    Disc2_footer_ar: "",
    Disc3_footer_ar: "",
    Disc4_footer_ar: "",
    Disc1_footer_en: "",
    Disc2_footer_en: "",
    Disc3_footer_en: "",
    Disc4_footer_en: "",
    MailBox: "",
    tax_ats: "",
    invval_ats: "",
    actv_elec: "",
    CustDisc: "",
    finyear_date1: "",
    finyear_date2: "",
    showimg: "",
    showvat: "",
    showdisc: "",
    showafterdisc: "",
    showtax: "",
    bank1: "",
    acc1: "",
    bank2: "",
    acc2: "",
    bank3: "",
    acc3: "",
    AddressEn: "",
    chkitemquan: "",
    msg: "",
    offer_type: "",
    VAT_Type: "",
    is_tab3: "",
    tab3val: "",
    consume_type: "",
    img: "",
    cnt: "",
    img2: "",
    contract_no: "",
    activity_name: "",
    city: "",
    branchName: "",
    sales_man: "",
    StartWorkDate: "",
    EndWorkDate: "",
    CStartWorkDate: "",
    CEndWorkDate: "",
    firstAlertDate: "",
    SecondAlertDate: "",
    ThirdAlertDate: "",
    StopWorkingDate: "",
    CStopWorkingDate: "",
    is$sys: "",
    is$$dessys: "",
    is$$$dy: "",
    server_name: "",
    point_name: "",
    status_type: "",
    computer_type: "",
    tax_no_build: "",
    tax_name_street: "",
    tax_name_district: "",
    tax_name_city: "",
    tax_name_country: "",
    tax_zip_code: "",
    tax_additional_address_no: "",
    tax_vat_registration_no: "",
  },
  Foundation_points: {
    id: "",
    nameA: "",
    nameE: "",
    FieldA: "",
    FieldE: "",
    bsn_no: "",
    licence_no: "",
    Address: "",
    Tel: "",
    Mobile: "",
    Fax: "",
    Email: "",
    website: "",
    Logo: "",
    Exchangeval: "",
    tax: "",
    port: "",
    tax_no: "",
    BillNotes: "",
    BillNotes1: "",
    BillNotes2: "",
    BillNotes3: "",
    Disc1_header_ar: "",
    Disc2_header_ar: "",
    Disc3_header_ar: "",
    Disc4_header_ar: "",
    Disc1_header_en: "",
    Disc2_header_en: "",
    Disc3_header_en: "",
    Disc4_header_en: "",
    Disc1_footer_ar: "",
    Disc2_footer_ar: "",
    Disc3_footer_ar: "",
    Disc4_footer_ar: "",
    Disc1_footer_en: "",
    Disc2_footer_en: "",
    Disc3_footer_en: "",
    Disc4_footer_en: "",
    MailBox: "",
    tax_ats: "",
    invval_ats: "",
    actv_elec: "",
    CustDisc: "",
    finyear_date1: "",
    finyear_date2: "",
    showimg: "",
    showvat: "",
    showdisc: "",
    showafterdisc: "",
    showtax: "",
    bank1: "",
    acc1: "",
    bank2: "",
    acc2: "",
    bank3: "",
    acc3: "",
    AddressEn: "",
    chkitemquan: "",
    msg: "",
    offer_type: "",
    VAT_Type: "",
    is_tab3: "",
    tab3val: "",
    consume_type: "",
    img: "",
    cnt: "",
    img2: "",
    contract_no: "",
    activity_name: "",
    city: "",
    branchName: "",
    sales_man: "",
    StartWorkDate: "",
    EndWorkDate: "",
    CStartWorkDate: "",
    CEndWorkDate: "",
    firstAlertDate: "",
    SecondAlertDate: "",
    ThirdAlertDate: "",
    StopWorkingDate: "",
    CStopWorkingDate: "",
    is$sys: "",
    is$$dessys: "",
    is$$$dy: "",
    server_name: "",
    point_name: "",
    status_type: "",
    computer_type: "",
    apps: "",
  },
  Branches: {
    id: "",
    name: "",
    Tel: "",
    Mobile: "",
    Fax: "",
    Email: "",
    Address: "",
    notes: "",
    IS_Deleted: "",
    IS_Default: "",
    IS_Active: "",
  },
  Units: {
    id: "",
    name: "",
    // IS_Default:'', IS_Active:'',
  },
  items: {
    id: "",
    symbol: "",
    nameEN: "",
    barcode: "1111",
    group_id: null,
    unit: null,
    // IS_Deleted:false,
    purch_price: "",
    sale_price: "",
    // limit:0,
    tax: 0,
    // discount:0,
    tax_group: null,
    // itemNo:null,
    min_sale_price: 0,
    // img:null,
    Distributor_price: 0,
    jomla_price: 0,
    // PakageNo:1,
    // Max_rate:0,
    // currency_type:null,
    // amount_disc:0,
    prody_date: moment(new Date()).format("YYYY-MM-DD"),
    expiry_date: moment(new Date()).format("YYYY-MM-DD"),
    is_tab3_curr: 0,
    // old_MinSalePrice:null,
    // favorite:0,
    // type:1,
    branch: locRem.branchi,
    subUnits: [],
    // post:2,
    // stop_trans:0,
    // Location:'',
  },
  khams: {
    id: "",
    symbol: "",
    nameEN: "",
    barcode: "1111",
    group_id: null,
    unit: null,
    // IS_Deleted:false,
    purch_price: "",
    sale_price: "",
    // limit:0,
    tax: 0,
    // discount:0,
    tax_group: null,
    // itemNo:null,
    min_sale_price: 0,
    // img:null,
    Distributor_price: 0,
    jomla_price: 0,
    // PakageNo:1,
    // Max_rate:0,
    // currency_type:null,
    // amount_disc:0,
    prody_date: moment(new Date()).format("YYYY-MM-DD"),
    expiry_date: moment(new Date()).format("YYYY-MM-DD"),
    is_tab3_curr: 0,
    // old_MinSalePrice:null,
    // favorite:0,
    // type:1,
    branch: locRem.branchi,
    subUnits: [],
    // post:2,
    // stop_trans:0,
    // Location:'',
  },
  groups: {
    id: "",
    name: "",
    nameEN: "",
    color: "",
    printer: "",
    group_id: "",
    parent_id: "",
    acc_branch: "",
  },
  tax_groups: {
    id: "",
    nameAR: "",
    nameEN: "",
    value: "",
    IS_Default: "",
    IS_Active: "",
    IS_DEL1: "",
    IS_Default1: "",
    IS_Active1: "",
    IS_Default111: "",
    IS_Active111: "",
    IS_Default112: "",
    IS_Active112: "",
    IS_Default113: "",
    IS_Active113: "",
    IS_Default114: "",
    IS_Active114: "",
  },
  Safes: {
    id: "",
    name: "",
    branch: "",
    status: "",
    IS_Default: false,
    notes: "",
    IS_Deleted: false,
    IS_Active: "",
    Safe_Emps: [],
  },
  Safe_Emps: {
    safe_id: null,
    emp_id: null,
  },
  Stocks: {
    id: "",
    name: "",
    branch: "",
    status: "",
    IS_Default: false,
    notes: "",
    IS_Deleted: false,
    IS_Active: "",
    Stock_Emps: [],
  },
  salesman: {
    id: "",
    name: "",
    comm: "",
    tel: "",
    email: "",
    mobile: "",
    notes: "",
  },
  Stock_Emps: {
    stock_id: null,
    emp_id: null,
  },
  Banks: {
    id: "",
    name: "",
    country: "",
    city: "",
    area: "",
    tel: "",
    mobile: "",
    notes: "",
    IS_Deleted: "",
    IS_Default: false,
    IS_Active: true,
    acc_no: "",
    acc_type: "",
  },
  costcenter: {
    id: "",
    Name: "",
    NameEN: "",
  },
  omlat: {
    id: "",
    name: "",
    exchange: "",
    IS_Default: "",
    IS_Active: "",
    symbol: "",
    NameEn: "",
    Country: "",
    FakaName: "",
    FakaNameEn: "",
    oneEqualto: "",
    TotalFaka: "",
    is_main: "",
    omla_desc: "",
  },
  Restrictions_Sub: {
    res_id: "",
    dept: "",
    credit: "",
    acc_no: "",
    notes: "",
    notes: "",
    branch: "",
    omla: "",
    omlaval: "",
    center: "",
    ref_no: "",
    RestDate: "",
    sub_type: "",
  },
  Restrictions: {
    id: "",
    date: "",
    doc_no: "",
    type: "",
    state: "",
    notes: "",
    branch: "",
    IS_Deleted: "",
    omla: "",
    omlaval: "",
    doc_no2: "",
    total_dept: "",
    total_credit: "",
    rest_type: "",
    rest_cycle_no: "",
    book_id: "",
    Center: "",
  },

  AccountBooks: {
    ID: "",
    book_id: "",
    Name: "",
    nameEN: "",
    parent_id: "",
    acc_branch: "",
  },
  Acts: {
    id: "",
    name: "",
    type: "",
  },
  Countries: { id: "", name: "", nationality: "", flag_img: "" },
  Cities: { id: "", name: "", country: "", durata_executie: "" },
  Areas: { id: "", name: "", city: "", kkk: "" },
  Managements: {
    id: "",
    name: "",
  },
  Departments: {
    id: "",
    manag_id: "",
    name: "",
  },
  jobs: {
    id: "",
    name: "",
  },
  CardTypes: {
    id: "",
    nameA: "",
    nameE: "",
  },

  // imore :{
  //   safe:-1,
  //   stock:-1,
  //   customer_name:'',
  //   cust_id:-1,
  //   salesman:-1,
  //   bank:-1,
  //   bank2:-1,
  //   center:-1,
  //   emp:-1,
  //   inv_type:2,

  //   pay_type:1
  //  },

  IdataInvs: {
    // auto Importent
    proc_id: null,

    //  proc_type:1,
    date: moment(new Date()).format("YYYY-MM-DD"),
    InvId_Return: "",
    // InvId_Return:null,
    // safe:-1,
    // stock:-1,
    safe: locSto?.Safes != undefined ? locSto?.Safes[0].id : -1,
    stock: locSto?.Stocks != undefined ? locSto?.Stocks[0].id : -1,
    inv_type: 2,
    cust_id: null,
    customer_name: "",
    // auto option
    salesman: -1,
    bank: -1,
    bank2: -1,
    center: -1,
    emp: -1,
    branch: locRem.branchi,
    sales_emp: locRem.empi,
    create_user: locRem.idi,
    update_user: null,
    minus: "", // discAmount :''
    // s sums
    tot_sale: 0,
    tot_purch: 0,
    netAmount: 0,
    netAmountPMDcn: "",
    amountBefordisc: "",
    amountAfterDisc: "",
    amountWithVat: "",
    amountOfVat: 0,
    // e sums
    Pay_mouny: "",
    Remaining: "",
    cash_part: "",
    network_part: "",
    agel_part: "",
    bank_part: "",
    emp_part: "",
    pay_type: 1,
    check_refno: "",
    refno: "",
    used_payed_window: null,
    notes: "",
    tab3Val: 0,
    trans_no: 0,
    transtrans_closed: 0,
    OrderNo: 0,
    OrderNoType: 1,
    OrderTypeA: '',
    OrderTypeE: '',
    po_no: "",
    trans_no: 0,
    post: 0,
    Ishar_type:null,
    Ishar_level:null,
    Ishar_amout:null,
    Ishar_Tax:null,
    Ishar_amout_Net:null,
    Dis_Code:''
  },

  sandQK: {
    id: "",
    date: moment(new Date()).format("YYYY-MM-DD"),
    // cust_id:locSto.CustomersA != undefined ? locSto.CustomersA[0].id: -1,
    cust_id: "",
    val: "",
    type: "1",
    safe_bank_id: locSto.Stocks != undefined ? locSto.Stocks[0].id : -1,
    sales_emp: locSto.Employees != undefined ? locSto.Employees[0].id : -1,
    check_no: "",
    check_date: moment(new Date()).format("YYYY-MM-DD"),
    checkbank: "",
    check_state: null,
    notes: "",
    rest_id: "",
    branch: locRem.branchi,
    center: "-1",
    ref_no: "",
    end_Dept: "",
  },

  sandQD: {
    id: "",
    date: moment(new Date()).format("YYYY-MM-DD"),
    emp_person: "1",
    cust_id: "",
    val: "",
    acc_code: "",
    type: "1",
    safe_bank_id: locSto.Stocks != undefined ? locSto.Stocks[0].id : -1,
    sales_emp: locSto.Employees != undefined ? locSto.Employees[0].id : -1,
    check_no: "",
    check_date: moment(new Date()).format("YYYY-MM-DD"),
    checkbank: "",
    check_state: null,
    notes: "",
    rest_id: "",
    branch: locRem.branchi,
    center: "-1",
    ref_no: "",
  },
  sandSD: {
    id: "",
    date: moment(new Date()).format("YYYY-MM-DD"),
    emp_person: "1",
    emp_id: "",
    val: "",
    acc_code: "",
    type: "1",
    safe_bank_id: locSto.Stocks != undefined ? locSto.Stocks[0].id : -1,
    sales_emp: locSto.Employees != undefined ? locSto.Employees[0].id : -1,
    check_no: "",
    check_date: moment(new Date()).format("YYYY-MM-DD"),
    checkbank: "",
    check_state: null,
    notes: "",
    rest_id: "",
    branch: locRem.branchi,
    center: "-1",
    ref_no: "",
  },

  sandDK: {
    id: "",
    date: moment(new Date()).format("YYYY-MM-DD"),
    emp_id: locSto.Employees != undefined ? locSto.Employees[0].id : -1,
    cust_id: "",
    val: "",
    type: "1",
    safe_bank_id: locSto.Stocks != undefined ? locSto.Stocks[0].id : -1,
    sales_emp: locSto.Employees != undefined ? locSto.Employees[0].id : -1,
    check_no: "",
    check_date: moment(new Date()).format("YYYY-MM-DD"),
    checkbank: "",
    check_state: null,
    notes: "",
    rest_id: "",
    branch: locRem.branchi,
    center: "-1",
    ref_no: "",
  },
  IdataSa: { ProcType_InvProc: "02" },
  IdataSaR: { ProcType_InvProc: "12" },
  IdataSaV: { ProcType_InvProc: "03" },
  IdataPuOr: { ProcType_InvProc: "04" },
  IdataPa: { ProcType_InvProc: "01" },
  IdataPaR: { ProcType_InvProc: "11" },
  IdataSf: { ProcType_InvProc: "22" },
  IdataMf: { ProcType_InvProc: "33" },
  IdataIsharDaen: { ProcType_InvProc: "150" },
  IdataIsharMed: { ProcType_InvProc: "149" },


  RptCustomer: {
    arsedah: {
      dateFrom: "2021-01-01",
      dateTo: moment(new Date()).format("YYYY-MM-DD"),
      cntr: -1,
      brnch: -1,
      accno: null,
      old: -1,
      Open: -1,
      type: 1,
    },
  },
  RptInv: [
    {
      tot_net_curr: "",
      val1: "",
      discount: "",
      new_exchange_price: "",
      symbol: "",
    },
  ],
  setting: {
    invoces: { CWVat: null, CWVtxt: "", titleHed: "", cusT: null, cusN: "" },
    customer: { type: null },
  },
  // >>>>>>>>>>> Select
  Auto: { id: -1, name: "" },
  AutoUits: { unit: -1, unitName: "", perc: 1, sale: 0, purch: 0, curId: 0 },

  auto: { group: "", groupSub: "" },
  AutoBank: { acc_no: -1, name: "", id: -1 },
  AutoT: [
    { id: 2, name: "نقدية" },
    { id: 1, name: "آجل" },
  ],
  AutoTNQd: { id: 2, name: "نقدية" },
  AutoTAgl: { id: 1, name: "آجل" },

  AutoOp: [{ id: -1, name: "فارغ" }],
  AutoBankOp: [{ acc_no: -1, name: "فارغ" }],
  AutoTypeOp: [{ id: 2, name: "فارغ" }],

  LoadAndSucc: {
    new: false,
    save: false,
    savetmp: false,
    savePMD: false,
    delete: false,
    print: false,
  },
  Sums: { val1: 0, netAmountSub: 0 },
  Payment: { paidup: 0, stay: 0, paidupPMDcn: "", stayPMDcn: "" },
  Remains: { agelPart: 0, cashPart: 0, networkPart: 0, bankPart: 0, empPart: 0, isAgel: false, isCash: false, isNetwork: false, isBank: false, isEmp: false, isWindow: false, empId: 0, bankId: 0, networkId: 0, stockName: "", allpart: 0, typePress: "save" },
  InvDisc: { rate: 0, minus: 0 },
  Snack: {
    openSnak: false,
    vertical: "",
    horizontal: "",
    severit: "",
    text: "",
    time: null,
  },
  // inshBarcode = {bc:''},
  Lbl: { chashNetwork: "كاش" },
  SwitchState: {
    stayInDCurr: locPremiA.stayInDCurr,
    tableOrscanBC: false,
    cashORnetworksw: false,
  },

  // >>>>> prim
  Or: {
    postput: "toPost",
    cros: "",
    /* prop:'Tst', postjust:'', putjust:'',*/ PrAC: 0,
    i: null,
  },
  ished: {
    hed: false,
    frmsrch: "no",
  },

  permiElm: {
    Ne: false,
    Sa: false,
    De: false,
    Se: false,
    Pr: false,
    Prv: false,
    Up: false,
    SaUp: false,
    TSP: false,
    ISPLP: false,
    USP: false,
    SIM: false,
    SVU: false,
    ASPZ: false,
    SDP: false,
    SDV: false,
    DSOI: false,
    DSOB: false,
    APDC: false,
    USD: false,
    UPD: false,
    RCNA: false,
    IPU: false,
  },

  prmiScr: {
    CWVat: false,
    Inv: false,
    Ret: false,
    chart: false,
    sal: false,
    salRet: false,
    purch: false,
    purchRet: false,
    safe: false,
    evrDay: false,
    eqfDay: false,
    activ: false,
    tafseel: false,
    safJrd: false,
    acc: false,
    custAcc: false,
    trycatch: false,
  },

  prmiScr1: [
    { screen: null },
    // {trycatch:null},
  ],

  PrmiCuCo: {
    yashml: "",
    CWVat: null,
    CWVtxt: "",
    HIB: null,
    DTSP: null,
    HPP: null,
    trycatch: null,
  },

  // >>>>> view
  UiElement: {
    stock: false,
    bank: true,
    bankPM: true,
    bankPM2: true,
    empPM: true,
    payMethod: false,
    rate: false,
    minus: false,
    /* shwo hide */
    DeleIcon: false,
    SaveIcon: false,
    ELMNTS: true,
  },

  Checked: {
    costWithVat: true,
    discMinusck: false,
    discRateck: false,
    networkck: false,
    cashck: true,

    paymentDiloagck: false,
    network_partck: false,
    cash_partck: false,
    agel_partck: false,
    bank_partck: false,
    emp_partck: false,

    autoOrStaticck: false,
  },

  con: {
    server: "",
    ipinsh: "",
    ip: "",
    changip: "",
    endDigtip: "",
    namedb: "",
    id: "",
    pass: "",
    port: ":",
    ftp: "",
    useUri: false,
    typeConnct: false,
    leavle: "",
  },


};

const cloudAPIs = [
  {
    name: "demoapp",
    phone: "55555",
    serv: "free.oraxmobile.com",
  }, {
    name: "safe",
    phone: "0559995751",
    serv: "safeasp.oraxmobile.com",
  }, {
    name: "nawi",
    phone: "55304",
    serv: "nawiasp.oraxmobile.com",
  }, {
    name: "ahmdShwqi",
    phone: "557650060",
    serv: "oraxapp-001-site2.itempurl.com",
  }, {
    name: "ramihalan",
    phone: "540265506",
    serv: "oraxapp-001-site4.itempurl.com",
  }, {
    name: "silverbox",
    phone: "0595751",
    serv: "sondq.oraxmobile.com",
  }, {
    name: "magles",
    phone: "0552265900",
    serv: "magles.oraxmobile.com",
  },
  {
    name: "alhelwa",
    phone: "202504",
    serv: "alhalwa.oraxmobile.com",
  }, {
    name: "almostaqbl",
    phone: "0568145331",
    serv: "almostaqbl.oraxmobile.com",
  }, {
    name: "alsodasia",
    phone: "0503586695",
    serv: "alsodasia.oraxerp.com",
  }, {
    name: "amazon",
    phone: "771999771",
    serv: "amazon.oraxerp.com",
  }, {
    name: "azharseven",
    phone: "0505999582",
    serv: "azhar7.oraxerp.com",
  }, {
    name: "hozan",
    phone: "0553614521",
    serv: "hozan.oraxerp.com",
  }, {
    name: "tobala",
    phone: "0563443882",
    serv: "tobala.oraxerp.com",
  }, {
    name: "albena",
    phone: "0506333893",
    serv: "albenaa.oraxerp.com",
  }, 
  // {
  //   name: "trana",
  //   phone: "0533123364",
  //   serv: "trana.oraxhotel.com",
  // }, 
  {
    name: "anwar",
    phone: "0554740417",
    serv: "anwar.oraxerp.com",
  }, {
    name: "alwanAltwreed",
    phone: "0503544021",
    serv: "alwanAltwreed.oraxhotel.com",
  }, {
    name: "qahwasalesa",
    phone: "056344",
    serv: "qahwa.oraxhotel.com",
  }, {
    name: "gawansharq",
    phone: "0505170604",
    serv: "gawanialshrq.oraxcloud.com",
  }, {
    name: "oniestplas",
    phone: "0552498575",
    serv: "oniestplas.oraxcloud.com",
  }, {
    name: "mamonaahmed",
    phone: "0559373935",
    serv: "mamona.oraxcloud.com",
  }, {
    name: "dekawikaya",
    phone: "0530003102",
    serv: "dekawikaya.oraxcloud.com",
  }, {
    name: "nasmah",
    phone: "0567959666",
    serv: "nasmah.oraxcloud.com",
  }, {
    name: "aljuda",
    phone: "0551092008",
    serv: "aljuda.oraxmobile.com",
  }, {
    name: "roaimelan",
    phone: "0200000000",
    serv: "roai3milan.oraxmobile.com",
  }, {
    name: "mageda",
    phone: "0506292616",
    serv: "mageda.oraxmobile.com",
  }, {
    name: "demo2",
    phone: "0554455",
    serv: "f.oraxcloud.com",
  }, {
    name: "aqwab_zahab",
    phone: "0591999975",
    serv: "aqwab-zahab.oraxcloud.com",
  }, {
    name: "mohand_said",
    phone: "0563576405",
    serv: "mohand-said.oraxcloud.com",
  }, {
    name: "ronq_tara",
    phone: "0581114277",
    serv: "ronq-tara.oraxcloud.com",
  }, {
    name: "almomares",
    phone: "0531209662",
    serv: "almomares.oraxmobile.com",
  }, {
    name: "asfar",
    phone: "0530058002",
    serv: "asfar.oraxcloud.com",
  }, {
    name: "shbakada",
    phone: "0562272221",
    serv: "shbakada.oraxmobile.com",
  }, {
    name: "shrakatdwa",
    phone: "203040",
    serv: "other.oraxmobile.com",
  }, {
    name: "holmsafar",
    phone: "0531878220",
    serv: "other2.oraxmobile.com",
  }, {
    name: "bareq_shemal",
    phone: "0504655339",
    serv: "other7.oraxcloud.com",
  }, {
    name: "sharkatalnama",
    phone: "0533653222",
    serv: "other4.oraxcloud.com",
  }, {
    name: "sharkatawsal",
    phone: "0503075062",
    serv: "other5.oraxcloud.com",
  }, {
    name: "sharkatemar",
    phone: "0532675513",
    serv: "other6.oraxcloud.com",
  }, {
    name: "alihammed",
    phone: "0566470852",
    serv: "other8.oraxcloud.com",
  }, {
    name: "rehamabdullah",
    phone: "0599919947",
    serv: "cust5.oraxcloud.com",
  }, {
    name: "mazaqtesaa",
    phone: "0502415050",
    serv: "other10.oraxcloud.com",
  }, {
    name: "alzoalnaqe",
    phone: "0539291333",
    serv: "other4.oraxmobile.com",
  }, {
    name: "alihasnalali",
    phone: "053072283",
    serv: "other5.oraxmobile.com",
  }, {
    name: "warshatfahad",
    phone: "0533211473",
    serv: "other6.oraxmobile.com",
  }, {
    name: "dalahherbd",
    phone: "0562608038",
    serv: "other7.oraxmobile.com",
  }, {
    name: "mazagzafran",
    phone: "0564926689",
    serv: "other11.oraxcloud.com",
  }, {
    name: "roqnalaselah",
    phone: "0554443593",
    serv: "other12.oraxcloud.com",
  }, {
    name: "droopalnjah",
    phone: "0531818218",
    serv: "other13.oraxcloud.com",
  }, {
    name: "enjazatwaselah",
    phone: "0554823384",
    serv: "other14.oraxcloud.com",
  }, {
    name: "haifajaza",
    phone: "0544696742",
    serv: "other15.oraxcloud.com",
  }, {
    name: "refaqalhkeer",
    phone: "0535000595",
    serv: "cust12.oraxcloudweb.com",
    // serv: "other8.oraxmobile.com",
  }, {
    name: "enarahqoom",
    phone: "0569113222",
    serv: "other9.oraxmobile.com",
  }, {
    name: "asasalmwasim",
    phone: "0538733",
    serv: "other10.oraxmobile.com",
  }, {
    name: "hozamialshariq",
    phone: "0507878203",
    serv: "other.oraxcloud.com",
  }, {
    name: "reefaltofeer",
    phone: "0547268665",
    serv: "other1.oraxmobile.com",
  }, {
    name: "ahmedabdulrahmin",
    phone: "0555202185",
    serv: "other11.oraxmobile.com",
  }, {
    name: "ensherahfoad",
    phone: "0533211",
    serv: "other12.oraxmobile.com",
  }, {
    name: "sanaasoltan",
    phone: "0555366489",
    serv: "other.oraxerp.com",
  }, {
    name: "hyahnadfa",
    phone: "0592797737",
    serv: "o.oraxerp.com",
  }, {
    name: "qmmnajed",
    phone: "0599368842",
    serv: "o1.oraxerp.com",
  }, {
    name: "mariambnaish",
    phone: "0533614255",
    serv: "o3.oraxerp.com",
  }, {
    name: "altofeeralnader",
    phone: "0581843082",
    serv: "o2.oraxerp.com",
  }, {
    name: "brakhmobark",
    phone: "0549298975",
    serv: "o4.oraxerp.com",
  }, {
    name: "ardarabia",
    phone: "0538592440",
    serv: "o5.oraxerp.com",
  }, {
    name: "handasaad",
    phone: "0541591040",
    serv: "o6.oraxerp.com",
  }, {
    name: "rwadaoola",
    phone: "0547111786",
    serv: "o7.oraxerp.com",
  }, {
    name: "norahali",
    phone: "0580511154",
    serv: "o8.oraxerp.com",
  }, {
    name: "fahdmusa",
    phone: "0581787878",
    serv: "o9.oraxerp.com",
  }, {
    name: "almsandalmia",
    phone: "0595555488",
    serv: "o10.oraxerp.com",
  }, {
    name: "njoomtamys",
    phone: "0505644295",
    serv: "o11.oraxerp.com",
  }, {
    name: "norahsaleh",
    phone: "0597610892",
    serv: "o12.oraxerp.com",
  }, {
    name: "eshardahab",
    phone: "0539051372",
    serv: "o13.oraxerp.com",
  }, {
    name: "sondokali",
    phone: "0503603339",
    serv: "o14.oraxerp.com",
  }, {
    name: "alarbiadeeb",
    phone: "0581240240",
    serv: "o15.oraxerp.com",
  }, {
    name: "aldwairmotkamel",
    phone: "0551805163",
    serv: "o16.oraxerp.com",
  }, {
    name: "harmalmoud",
    phone: "0540243606",
    serv: "o17.oraxerp.com",
  }, {
    name: "mazyaalalem",
    phone: "0555908941",
    serv: "o18.oraxerp.com",
  }, {
    name: "derasahar",
    phone: "0594448592",
    serv: "o19.oraxerp.com",
  }, {
    name: "adwaalmno",
    phone: "0501642053",
    serv: "o20.oraxerp.com",
  }, {
    name: "fatemaSalem",
    phone: "0550547927",
    serv: "o21.oraxerp.com",
  }, {
    name: "waqtalmezag",
    phone: "0547749224",
    serv: "o22.oraxerp.com",
  }, {
    name: "waqtalmezag2",
    phone: "054774",
    serv: "o23.oraxerp.com",
  }, {
    name: "baitaledaa",
    phone: "0569935805",
    serv: "o24.oraxerp.com",
  }, {
    name: "dalaatfal",
    phone: "0509100961",
    serv: "o26.oraxerp.com",
  }, {
    name: "alrexteqnia",
    phone: "0503724702",
    serv: "o27.oraxerp.com",
  }, {
    name: "alsaqralazraq",
    phone: "053859",
    serv: "o28.oraxerp.com",
  }, {
    name: "taqweenemar",
    phone: "0500955556",
    serv: "o29.oraxerp.com",
  }, {
    name: "masarared",
    phone: "0595149449",
    serv: "o30.oraxerp.com",
  }, {
    name: "ghalasweet",
    phone: "0500058539",
    serv: "o31.oraxerp.com",
  }, {
    name: "warqkhadmat",
    phone: "0552793283",
    serv: "o32.oraxerp.com",
  }, {
    name: "hesamohammed",
    phone: "0597775591",
    serv: "o33.oraxerp.com",
  }, {
    name: "shaishieb",
    phone: "00563444",
    serv: "o34.oraxerp.com",
  }, {
    name: "aqoolmohtrefa",
    phone: "0558572665",
    serv: "o35.oraxerp.com",
  }, {
    name: "cust_six",
    phone: "6002600",
    serv: "o36.oraxerp.com",
  }, {
    name: "brooqnokhbah",
    phone: "0501262176",
    serv: "o37.oraxerp.com",
  }, {
    name: "byootetow",
    phone: "0500095068",
    serv: "o38.oraxerp.com",
  }, {
    name: "alrabeeaqaria",
    phone: "0597633278",
    serv: "o39.oraxerp.com",
  }, {
    name: "aljamalalsharqe",
    phone: "503603339",
    serv: "o40.oraxerp.com",
  }, {
    name: "makhbazdorah",
    phone: "0599694725",
    serv: "o41.oraxerp.com",
  }, {
    name: "emdadataldaam",
    phone: "0541032233",
    serv: "o42.oraxerp.com",
  }, {
    name: "suadfesalmohammed",
    phone: "0507719192",
    serv: "cust1.oraxcloud.com",
  }, {
    name: "almostaqbalteq",
    phone: "0508380010",
    serv: "cust2.oraxcloud.com",
  }, {
    name: "madadasemah",
    phone: "0532959946",
    serv: "cust3.oraxcloud.com",
  }, {
    name: "mdarmraa",
    phone: "0538733350",
    serv: "cust4.oraxcloud.com",
  }, {
    name: "hasanmohammedali",
    phone: "0501233197",
    serv: "cust6.oraxcloud.com",
  }, {
    name: "halawyatwazyadah",
    phone: "0558872640",
    serv: "cust7.oraxcloud.com",
  }, {
    name: "netaq_alfedi",
    phone: '0555022986',
    serv: 'cust8.oraxcloud.com'
  }, {
    name: "alters_aldaki",
    phone: '0568390161',
    serv: 'cust9.oraxcloud.com'
  }, {
    name: "abdulrahmanmarzooq",
    phone: '0553510416',
    serv: 'cust10.oraxcloud.com'
  }, {
    name: "mostafaalbnaa",
    phone: '0536682919',
    serv: 'cust11.oraxcloud.com'
  }, {
    name: "haber_dwagin",
    phone: '0530566252',
    serv: 'cust12.oraxcloud.com'
  },
  {
    name: "saadsaleh",
    phone: '0544839427',
    serv: 'cust13.oraxcloud.com'
  },
  {
    name: "ronaqfoundation",
    phone: '0543516721',
    serv: 'cust14.oraxcloud.com'
  },
  {
    name: "aljuda_khyar",
    phone: '0551092008',
    serv: 'cust15.oraxcloud.com'
  },
  {
    name: "makhbaz_fosool",
    phone: '0554573460',
    serv: 'cust16.oraxcloud.com'
  },
  {
    name: "orax_aqar",
    phone: '0552661598',
    serv: 'cust17.oraxcloud.com'
  },
  {
    name: "anaam_sharorah",
    phone: '0555496152',
    serv: 'cust18.oraxcloud.com'
  },
  {
    name: "serag_motaheda",
    phone: '0509463807',
    serv: 'cust19.oraxcloud.com'
  },
  {
    name: "njoom_hala",
    phone: '0501010042',
    serv: 'cust20.oraxcloud.com'
  },
  {
    name: "abdulrahman_jaber",
    phone: '0551552888',
    serv: 'cust21.oraxcloud.com'
  },
  {
    name: "khayratfadelah",
    phone: '0506322079',
    serv: 'cust22.oraxcloud.com'
  },
  {
    name: "khalilmathaq",
    phone: '0502470096',
    serv: 'cust23.oraxcloud.com'
  },
  {
    name: "abdulazizmohammed",
    phone: '0566668451',
    serv: 'cust24.oraxcloud.com'
  },
  {
    name: "MahtatAbeedEbrahim",
    phone: '0506272277',
    serv: 'cust24.oraxmobile.com'
  },
  {
    name: "wahgmoshea",
    phone: '056993',
    serv: 'cust25.oraxcloud.com'
  },
  {
    name: "altamleeklltaqyeem",
    phone: '0599477777',
    serv: 'cust26.oraxcloud.com'
  },
  {
    name: "mohammedsiadomer",
    phone: '0507578175',
    serv: 'cust27.oraxcloud.com'
  },
  {
    name: "shafialhadetha",
    phone: '0536955723',
    serv: 'cust28.oraxcloud.com'
  },
  {
    name: "tagalezllsianah",
    phone: '0580910196',
    serv: 'cust29.oraxcloud.com'
  },
  {
    name: "nasmatalsahraa",
    phone: '0560480084',
    serv: 'cust30.oraxcloud.com'
  },
  {
    name: "wadialghadaa",
    phone: '0532284736',
    serv: 'cust31.oraxcloud.com'
  },
  {
    name: "lamasatkonafa",
    phone: '0550066074',
    serv: 'cust32.oraxcloud.com'
  },
  {
    name: "ebrahimAlimohammed",
    phone: '0535752209',
    serv: 'cust33.oraxcloud.com'
  },
  {
    name: "taybatyoom",
    phone: '0530039398',
    serv: 'cust34.oraxcloud.com'
  },
  {
    name: "waraqalkhaeeg",
    phone: '0595459717',
    serv: 'cust35.oraxcloud.com'
  },
  {
    name: "deltaalnaseem",
    phone: '0504754494',
    // serv: 'cust36.oraxcloud.com',
    serv: 'cust23.oraxcloudweb.com'
  },
  {
    name: "morabaamasi",
    phone: '0554060956',
    serv: 'cust37.oraxcloud.com'
  },
  {
    name: "TaifAlremal",
    phone: '0562398551',
    serv: 'cust15.oraxcloudweb.com'
    // serv: 'cust38.oraxcloud.com'
  },
  {
    name: "WahgMotheeeT",
    phone: '05016420',
    serv: 'cust39.oraxcloud.com'
  },
  {
    name: "TalalOrax",
    phone: '05656277',
    // serv: 'cust40.oraxcloud.com'
    serv: 'cust20.oraxcloudweb.com'
  },
  {
    name: "amalSaad",
    phone: '0571730348',
    serv: 'cust41.oraxcloud.com'
  },
  {
    name: "zwayashakhsia",
    phone: '0555088012',
    serv: 'cust42.oraxcloud.com'
  },
  {
    name: "taqfoorzedan",
    phone: '0556946764',
    serv: 'cust43.oraxcloud.com'
  },
  {
    name: "meethZahbeya",
    phone: '0509356091',
    serv: 'cust44.oraxcloud.com'
  },
  {
    name: "CustomerOne",
    phone: '0505055',
    serv: 'cust45.oraxcloud.com'
  },
  {
    name: "CustomerTow",
    phone: '0506650',
    serv: 'cust46.oraxcloud.com'
  },
  {
    name: "CustomerThree",
    phone: '0556053546',
    serv: 'cust47.oraxcloud.com'
  },
  {
    name: "RoohAlnaqaa",
    phone: '0533774861',
    serv: 'cust5.oraxcloudweb.com'
    // serv: 'cust48.oraxcloud.com'
  },
  {
    name: "mashaandlymathaan",
    phone: '0552719224',
    serv: 'cust49.oraxcloud.com'
  },
  {
    name: "masaratAltaqaa",
    phone: '0597229576',
    serv: 'cust50.oraxcloud.com'
  },
  {
    name: "njoomalebteqar",
    phone: '0536063980',
    serv: 'cust51.oraxcloud.com'
  },
  {
    name: "omeralijabri",
    phone: '0556658664',
    serv: 'cust52.oraxcloud.com'
  },
  {
    name: "moqrenabdulaziz",
    phone: '0569888700',
    serv: 'cust53.oraxcloud.com'
  },
  {
    name: "AlkonoozAlmomaiz",
    phone: '0552225927',
    serv: 'cust54.oraxcloud.com'
  },
  {
    name: "suadBnMoamer",
    phone: '0570950250',
    serv: 'cust55.oraxcloud.com'
  },
  {
    name: "DeraAlemdaad",
    phone: '0567300057',
    serv: 'cust56.oraxcloud.com'
  },
  {
    name: "RoqnAltofeer",
    phone: '0539211076',
    serv: 'cust57.oraxcloud.com'
  },
  {
    name: "hassanNasser",
    phone: '0504810993',
    serv: 'cust58.oraxcloud.com'
  },
  {
    name: "ArdAlaryaaf",
    phone: '0533055506',
    serv: 'cust59.oraxcloud.com'
  },
  {
    name: "AjmalAL-zohoor",
    phone: '0508813798',
    serv: 'cust4.oraxcloudweb.com'
    // serv: 'cust60.oraxcloud.com'
  },
  {
    name: "AsdafAlAamri",
    phone: '0560083469',
    serv: 'cust61.oraxcloud.com'
  },
  {
    name: "TagAlmash",
    phone: '0530862817',
    serv: 'cust62.oraxcloud.com'
  },
  {
    name: "NasmahAlmethaq",
    phone: '0504660752',
    serv: 'cust63.oraxcloud.com'
  },
  {
    name: "mahaltaag",
    phone: '0566007969',
    serv: 'cust64.oraxcloud.com'
  },
  {
    name: "AdelMohommed",
    phone: '0556692321',
    serv: 'cust65.oraxcloud.com'
  },
  {
    name: "SaderatAlasemah",
    phone: '0540426428',
    serv: 'cust66.oraxcloud.com'
  },
  {
    name: "HalaHesa",
    phone: '0544467959',
    serv: 'cust67.oraxcloud.com'
  },
  {
    name: "NetaqAlfedi2024",
    phone: '053424',
    serv: 'cust68.oraxcloud.com'
  },
  {
    name: "abaarllwqood",
    phone: '0535867428',
    serv: 'cust69.oraxerp.com'
  },
  {
    name: "alaaAldeen",
    phone: '0553827390',
    serv: 'cust69.oraxerp.com'
  },
  {
    name: "shawyaAlkhaleeg",
    phone: '0538035363',
    serv: 'cust70.oraxerp.com'
  },
  {
    name: "jaleezmohadath",
    phone: '0571331198',
    serv: 'cust71.oraxerp.com'
  },
  {
    name: "AlmobtakerLeldayah",
    phone: '0593355549',
    serv: 'cust72.oraxerp.com'
  },
  {
    name: "ZadAlhaseed",
    phone: '0550499852',
    serv: 'cust73.oraxerp.com'
  },

  {
    name: "WarshatEbdaa",
    phone: '0565619580',
    serv: 'cust74.oraxerp.com'
  },
  {
    name: "Taibahabdulah",
    phone: '0581577595',
    serv: 'cust75.oraxerp.com'
  },
  {
    name: "jebalaseer",
    phone: '0566056097',
    serv: 'cust66.oraxerp.com'
  },
  {
    name: "salehamohammed",
    phone: '0562201500',
    serv: 'cust67.oraxerp.com'
  },
  {
    name: "eshraqattaleen",
    phone: '0530115006',
    serv: 'cust68.oraxerp.com'
  },
  {
    name: "adwaaareed",
    phone: '0557936668',
    serv: 'cust69.oraxcloud.com'
  },
  {
    name: "moqsratdooq",
    phone: '0506546264',
    serv: 'cust70.oraxcloud.com'
  },
  {
    name: "brooqAlsahraa",
    phone: '0555736381',
    serv: 'cust71.oraxcloud.com'
  },
  {
    name: "wodyanalbon",
    phone: '0533988542',
    serv: 'cust72.oraxcloud.com'
  },
  {
    name: "alremahAlzahbia",
    phone: '0555961677',
    serv: 'cust73.oraxcloud.com'
  },
  {
    name: "ZyeetFaaz",
    phone: '0592443296',
    serv: 'cust74.oraxcloud.com'
  },
  {
    name: "AwogLelKhadmat",
    phone: '0565093709',
    serv: 'cust75.oraxcloud.com'
  },
  {
    name: "ManazelAljazera",
    phone: '0506025627',
    serv: 'cust76.oraxcloud.com'
  },
  {
    name: "fisalaliSahari",
    phone: '0550311699',
    serv: 'cust77.oraxcloud.com'
  },
  {
    name: "fadishoee",
    phone: '0590773713',
    serv: 'cust78.oraxcloud.com'
  },
  {
    name: "mobarkMosood",
    phone: '0537918188',
    serv: 'cust79.oraxcloud.com'
  },
  {
    name: "alnorasAlsaree",
    phone: '0501088229',
    serv: 'cust80.oraxcloud.com'
  },
  {
    name: "DowarAnaam",
    phone: '0559541109',
    serv: 'cust81.oraxcloud.com'
  },
  {
    name: "alhashabAlsharqi",
    phone: '05036033399',
    serv: 'cust82.oraxcloud.com'
  },
  {
    name: "TelalAlderah",
    phone: '0567358835',
    serv: 'cust83.oraxcloud.com'
  },
  {
    name: "SadratHeger",
    phone: '0536963900',
    serv: 'cust25.oraxcloudweb.com'
    // serv: 'cust25.oraxcloudweb.com'
  },
  {
    name: "BoharatKhater",
    phone: '0555133424',
    serv: 'cust85.oraxcloud.com'
  },
  {
    name: "AboSami",
    phone: '0503133174',
    serv: 'cust107.oraxcloud.com'
  },
  {
    name: "AbdullahMobarAlsyri",
    phone: '0552388845',
    serv: 'cust86.oraxcloud.com'
  },
  {
    name: "SaanWaAqthar",
    phone: '0501302448',
    serv: 'cust87.oraxcloud.com'
  },
  {
    name: "AltolahAlaselah",
    phone: '0501374089',
    serv: 'cust88.oraxcloud.com'
  },
  {
    name: "alJamerAlabyad",
    phone: '0557774504',
    serv: 'cust89.oraxcloud.com'
  },
  {
    name: "alJamerAlabyad2",
    phone: '05577745',
    serv: 'cust90.oraxcloud.com'
  },
  {
    name: "roohaalnaqaa2024",
    phone: '05004999',
    serv: 'cust91.oraxcloud.com'
  },
  {
    name: "SalemMastoors",
    phone: '0504300122',
    // serv: 'cust92.oraxcloud.com'
    serv: 'cust22.oraxcloudweb.com'
  },
  {
    name: "TairAlkheer",
    phone: '0536849082',
    serv: 'cust93.oraxcloud.com'
  },
  {
    name: "LyliAlhgarbia",
    phone: '0530890855',
    serv: 'cust94.oraxcloud.com'
  },
  {
    name: "ZawyaAlseer",
    phone: '0536757121',
    serv: 'cust95.oraxcloud.com'
  },
  {
    name: "EmdadAljanobia",
    phone: '0551199407',
    serv: 'cust96.oraxcloud.com'
  },
  {
    name: "AltarsheedWalemdad",
    phone: '0500870050',
    serv: 'cust97.oraxcloud.com'
  },
  {
    name: "AflaqAlfolaz",
    phone: '0549395554',
    serv: 'cust98.oraxcloud.com'
  },
  {
    name: "AlzakeraAlzahbia",
    phone: '0500017627',
    serv: 'cust99.oraxcloud.com'
  },
  {
    name: "AlaziziaAljadeed",
    phone: '0596335998',
    serv: 'cust100.oraxcloud.com'
  },
  {
    name: "KhalidMahmood",
    phone: '000543333791',
    serv: 'cust101.oraxcloud.com'
  },
  {
    name: "AbdullahAadah",
    phone: '0507982851',
    serv: 'cust102.oraxcloud.com'
  },
  {
    name: "BansherAbraaq",
    phone: '0504607114',
    serv: 'cust103.oraxcloud.com'
  },
  {
    name: "AsalatAldamam",
    phone: '0507298144',
    serv: 'cust104.oraxcloud.com'
  },
  {
    name: "TalabiaLelkhadmat",
    phone: '0599374900',
    serv: 'cust105.oraxcloud.com'
  },
  {
    name: "khaledAbdulaziz",
    phone: '0539649452',
    serv: 'cust106.oraxcloud.com'
  },
  {
    name: "mahtatAbdullah",
    phone: '0544419003',
    serv: 'cust108.oraxcloud.com'
  },
  {
    name: "nadeegAlbasateen",
    phone: '0530530938',
    serv: 'cust109.oraxcloud.com'
  },
  {
    name: "aqtharAnaqa",
    phone: '0551368754',
    serv: 'cust110.oraxcloud.com'
  },
  {
    name: "tezqaralmadena",
    phone: '1357',
    serv: 'cust1.oraxmobile.com'
  },
  {
    name: "almasaderAlola",
    phone: '0547403643',
    serv: 'cust2.oraxmobile.com'
  },
  {
    name: "matamLahm",
    phone: '0551483837',
    serv: 'cust3.oraxmobile.com'
  },
  {
    name: "BoleesBro",
    phone: '0569582320',
    serv: 'cust4.oraxmobile.com'
  },
  {
    name: "SharqatMedadALsharqia",
    phone: '0535771394',
    serv: 'cust5.oraxmobile.com'
  },
  {
    name: "CarLelkhadmat",
    phone: '0503337838',
    serv: 'cust6.oraxmobile.com'
  },
  {
    name: "BoharatKhaterBranch2",
    phone: '050050',
    serv: 'cust7.oraxmobile.com'
  },
  {
    name: "WashahAlmashaheer",
    phone: '0581815222',
    serv: 'cust8.oraxmobile.com'
  },
  {
    name: "shoqaqAlwesam",
    phone: '0555662532',
    serv: 'cust9.oraxmobile.com'
  },
  {
    name: "mohammedTalaat",
    phone: '0566018232',
    serv: 'cust10.oraxmobile.com'
  },
  {
    name: "tawredaatForya",
    phone: '0530322115',
    serv: 'cust11.oraxmobile.com'
  },
  {
    name: "sadaSabaah",
    phone: '0503892604',
    serv: 'cust12.oraxmobile.com'
  },
  {
    name: "HasawiTrading",
    phone: '0562674447',
    serv: 'cust13.oraxmobile.com'
  },
  {
    name: "MahtatSaid",
    phone: '0536754232',
    serv: 'cust14.oraxmobile.com'
  },
  {
    name: "SaraBalqasem",
    phone: '0530811486',
    serv: 'cust15.oraxmobile.com'
  },
  {
    name: "AlbyootCompany",
    phone: '0565555572',
    serv: 'cust16.oraxmobile.com'
  },
  {
    name: "EsmailFatah",
    phone: '0544185660',
    serv: 'cust17.oraxmobile.com'
  },
  {
    name: "AlnetaqAlmadi",
    phone: '0591226727',
    serv: 'cust18.oraxmobile.com'
  },
  {
    name: "AsematAlAthair",
    phone: '00539211076',
    serv: 'cust19.oraxmobile.com'
  },
  {
    name: "DanatAtaa",
    phone: '0533369180',
    serv: 'cust20.oraxmobile.com'
  },
  {
    name: "DaarAlmahara",
    phone: '0507427767',
    serv: 'cust21.oraxmobile.com'
  },
  {
    name: "SaderAlmaden",
    phone: '0565720618',
    serv: 'cust22.oraxmobile.com'
  },
  {
    name: "RoyalCrestal",
    phone: '0505919202',
    // serv: 'cust23.oraxmobile.com'
    serv: 'cust11.oraxcloudweb.com'
  },
  {
    name: "soltanalialiabeeri",
    phone: '0535006970',
    serv: 'cust25.oraxmobile.com'
  },
  {
    name: "FaqehatOmer",
    phone: '0538881141',
    serv: 'cust26.oraxmobile.com'
  },
  {
    name: "thalagatmoshref",
    phone: '000560472538',
    serv: 'cust27.oraxmobile.com'
  },
  {
    name: "wahgmotheethree",
    phone: '0507762998',
    serv: 'cust28.oraxmobile.com'
  },
  {
    name: "DeploOne",
    phone: '0549995914',
    serv: 'cust29.oraxmobile.com'
  },
  {
    name: "JaasLelWoqood",
    phone: '0542680800',
    serv: 'cust30.oraxmobile.com'
  },
  {
    name: "hammedAbdullahSaleh",
    phone: '0505209159',
    serv: 'cust31.oraxmobile.com'
  },
  {
    name: "AlesnadAlmasi",
    phone: '0538459425',
    serv: 'cust32.oraxmobile.com'
  },
  {
    name: "halaAlfakhera",
    phone: '0553616275',
    serv: 'cust33.oraxmobile.com'
  },
  {
    name: "waqetAlsianah",
    phone: '0554791887',
    serv: 'cust34.oraxmobile.com'
  },
  {
    name: "alshadsweet",
    phone: '0551372365',
    serv: 'cust35.oraxmobile.com'
  },
  {
    name: "FarshAlnaam",
    phone: '0566233612',
    // serv: 'cust36.oraxmobile.com'
    serv: 'cust21.oraxcloudweb.com'
  },
  {
    name: "KendiSharorah",
    phone: '0533494895',
    serv: 'cust37.oraxmobile.com'
  },
  {
    name: "SanadelAlfaow",
    phone: '0562519190',
    serv: 'cust38.oraxmobile.com'
  },
  {
    name: "MohammedAbdoraboh",
    phone: '05070705070',
    serv: 'cust39.oraxmobile.com'
  },
  {
    name: "ZohoorMaiz",
    phone: '0500016032',
    serv: 'cust40.oraxmobile.com'
  },
  {
    name: "JomlatFares",
    phone: '0541411373',
    serv: 'cust41.oraxmobile.com'
  },
  {
    name: "AwatefDwiyhi",
    phone: '0547355022',
    serv: 'cust42.oraxmobile.com'
  },
  {
    name: "AkhoonTrading",
    phone: '0550551929',
    // serv: 'cust1.oraxcloudweb.com'
    serv: 'cust43.oraxmobile.com'
  },
  {
    name: "Abdulazizkhalid",
    phone: '0504439330',
    serv: 'cust44.oraxmobile.com'
  },
  {
    name: "HosainMohammed",
    phone: '0544130230',
    serv: 'cust45.oraxmobile.com'
  },
  {
    name: "RahatyTrading",
    phone: '0536424752',
    serv: 'cust46.oraxmobile.com'
  },
  {
    name: "AbdoAlsanadi",
    phone: '0551389745',
    serv: 'cust47.oraxmobile.com'
  },
  {
    name: "DokhenWadaqeeq",
    phone: '0530320631',
    serv: 'cust48.oraxmobile.com'
  },
  {
    name: "WarshatFahed3",
    phone: '000533211',
    serv: 'cust49.oraxmobile.com'
  },
  {
    name: "AlkarazAlhelo",
    phone: '0534560478',
    serv: 'cust50.oraxmobile.com'
  },
  {
    name: "MazalatAlebdaa",
    phone: '0533521000',
    serv: 'cust51.oraxmobile.com'
  },
  {
    name: "SuperBaby",
    phone: '0557755801',
    serv: 'cust52.oraxmobile.com'
  },
  {
    name: "DantailCompany",
    phone: '0531819465',
    serv: 'cust53.oraxmobile.com'
  },
  {
    name: "RoqenWao",
    phone: '0502190846',
    serv: 'cust54.oraxmobile.com'
  },
  {
    name: "LamaatAsalah",
    phone: '0559312858',
    serv: 'cust55.oraxmobile.com'
  },
  {
    name: "FarOrpit",
    phone: '0508722293',
    serv: 'cust56.oraxmobile.com'
  },
  {
    name: "SaloonAlnogoom",
    phone: '0546170786',
    serv: 'cust57.oraxmobile.com'
  },
  {
    name: "NafsAlnakhlah",
    phone: '0510039105',
    serv: 'cust14.oraxcloudweb.com'
    // serv: 'cust58.oraxmobile.com'
  },
  {
    name: "mobileTalalYemen",
    phone: '734422463',
    serv: 'cust59.oraxmobile.com'
  },
  {
    name: "BasemRami",
    phone: '0559129189',
    serv: 'cust60.oraxmobile.com'
  },
  {
    name: "mataamWalemah",
    phone: '0533773379',
    serv: 'cust61.oraxmobile.com'
  },
  {
    name: "ZabayhAmjad",
    phone: '0556029890',
    serv: 'cust13.oraxcloudweb.com'
    // serv: 'cust62.oraxmobile.com'
  },
  {
    name: "AbdullahFaisSalem",
    phone: '0505555901',
    serv: 'cust63.oraxmobile.com'
  },
  {
    name: "SharkatWtaawon",
    phone: '0550521732',
    serv: 'cust64.oraxmobile.com'
  },
  {
    name: "AlAlafAlthalathah",
    phone: '0562908880',
    serv: 'cust65.oraxmobile.com'
  },
  {
    name: "QaserAlkhazaen",
    phone: '0500103042',
    serv: 'cust66.oraxmobile.com'
  },
  {
    name: "samaaAleez",
    phone: '0502006001',
    serv: 'cust67.oraxmobile.com'
  },
  {
    name: "mohammedBnRjeh",
    phone: '0506688321',
    serv: 'cust68.oraxmobile.com'
  },
  {
    name: "reemAlharthi",
    phone: '0545863420',
    serv: 'cust69.oraxmobile.com'
  },
  {
    name: "almadaAraqami",
    phone: '0500313113',
    serv: 'cust70.oraxmobile.com'
  },
  {
    name: "ByBretekesCompany",
    phone: '0570484214',
    serv: 'cust71.oraxmobile.com'
  },
  {
    name: "hannanAlAlbohari",
    phone: '0570652242',
    serv: 'cust72.oraxmobile.com'
  },
  {
    name: "AsdaaAltamyoos",
    phone: '0591751305',
    serv: 'cust73.oraxmobile.com'
  },
  {
    name: "RyahAlshraa",
    phone: '0501807897',
    serv: 'cust74.oraxmobile.com'
  },
  {
    name: "AmaanWasat",
    phone: '0593377349',
    serv: 'cust75.oraxmobile.com'
  },
  {
    name: "AhlaTasmeemCompany",
    phone: '0530883334',
    // serv: 'cust76.oraxmobile.com'
    serv: 'cust18.oraxcloudweb.com'
  },
  {
    name: "DaleelAlmakaseb",
    phone: '0557441113',
    serv: 'cust77.oraxmobile.com'
  },
  {
    name: "thlagetMoshref",
    phone: '00056047253',
    serv: 'cust78.oraxmobile.com'
  },
  {
    name: "altyoorAlnaderah",
    phone: '0580939060',
    serv: 'cust79.oraxmobile.com'
  },
  {
    name: "GamratForsan",
    phone: '0507435283',
    serv: 'cust80.oraxmobile.com'
  },
  {
    name: "EnsherahFaud",
    phone: '0559566887',
    serv: 'cust81.oraxmobile.com'
  },
  {
    name: "SaifFaqtori",
    phone: '0551554853',
    serv: 'cust82.oraxmobile.com'
  },
  {
    name: "JomaltAljood",
    phone: '0552545840',
    serv: 'cust83.oraxmobile.com'
  },
  {
    name: "AlzahabiAlsharqee",
    phone: '0546918067',
    serv: 'cust84.oraxmobile.com'
  },
  {
    name: "AccountRohaaAlnaqaa",
    phone: '00500499968',
    serv: 'cust85.oraxmobile.com'
  },
  {
    name: "ZogoorAlQool",
    phone: '0557117034',
    serv: 'cust86.oraxmobile.com'
  },
  {
    name: "ReemFoundation",
    phone: '0500665571',
    serv: 'cust87.oraxmobile.com'
  },
  {
    name: "AsaadTaleb",
    phone: '0599026127',
    serv: 'cust88.oraxmobile.com'
  },
  {
    name: "AyishaMohammed",
    phone: '0508354195',
    serv: 'cust89.oraxmobile.com'
  },
  {
    name: "ZabayhAmjadAccount",
    phone: '00556029890',
    serv: 'cust90.oraxmobile.com'
  },
  {
    name: "RehaltAlkhaleeg",
    phone: '0555328215',
    serv: 'cust91.oraxmobile.com'
  },
  {
    name: "SamSetah",
    phone: '0509971297',
    serv: 'cust92.oraxmobile.com'
  },
  {
    name: "lamsatBazar",
    phone: '0500096683',
    serv: 'cust93.oraxmobile.com'
  },
  {
    name: "RoqenAlsaryaa",
    phone: '0530666766',
    serv: 'cust94.oraxmobile.com'
  },
  {
    name: "RoqenAlQyeef",
    phone: '0559990912',
    serv: 'cust95.oraxmobile.com'
  },
  {
    name: "YallowLelEtsalat",
    phone: '0551219083',
    serv: 'cust96.oraxmobile.com'
  },
  {
    name: "RoqenAlsaryaabranch2",
    phone: '00530666766',
    serv: 'cust97.oraxmobile.com'
  },
  {
    name: "NaqhatAlfarwlah",
    phone: '05609020',
    serv: 'cust24.oraxcloudweb.com'
    // serv: 'cust98.oraxmobile.com'
  },
  {
    name: "SoltanOmar",
    phone: '0560783577',
    serv: 'cust99.oraxmobile.com'
  },
  {
    name: "RakaezAlmohtaref",
    phone: '0540393366',
    serv: 'cust100.oraxmobile.com'
  },
  {
    name: "QahwatiAlfakhera",
    phone: '0505765281',
    serv: 'cust101.oraxmobile.com'
  },
  {
    name: "ShoaaNokhbahCompany",
    phone: '0537578818',
    serv: 'cust9.oraxcloudweb.com'
    // serv: 'cust102.oraxmobile.com'
  },
  {
    name: "AlKhatAlbadeel",
    phone: '0551617675',
    serv: 'cust103.oraxmobil+e.com'
  },
  {
    name: "BasmatRetag",
    phone: '0558176391',
    serv: 'cust104.oraxmobile.com'
  },
  {
    name: "MontagatAlahlaam",
    phone: '0555582467',
    serv: 'cust105.oraxmobile.com'
  },
  {
    name: "ZawayatAlsiarBranch2",
    phone: '00552542785',
    serv: 'cust106.oraxmobile.com'
  },
  {
    name: "SednAljazeraCompany",
    phone: '0556200196',
    serv: 'cust107.oraxmobile.com'
  },
  {
    name: "ArqaamAlwaan",
    phone: '0502749403',
    serv: 'cust108.oraxmobile.com'
  },
  {
    name: "BasamAlRaedah",
    phone: '0508888334',
    serv: 'cust109.oraxmobile.com'
  },
  {
    name: "ZelAlbonyan",
    phone: '0533087326',
    serv: 'cust110.oraxmobile.com'
  },
  {
    name: "KianSalman",
    phone: '0557707496',
    serv: 'cust111.oraxmobile.com'
  },
  {
    name: "EbrahimMohammedAl",
    phone: '0598883662',
    serv: 'cust112.oraxmobile.com'
  },
  {
    name: "RwaeeEbdaa",
    phone: '0543946294',
    serv: 'cust113.oraxmobile.com'
  },
  {
    name: "RwadAlMasaarAlMotqadem",
    phone: '0532082285',
    serv: 'cust114.oraxmobile.com'
  },
  {
    name: "fahadAhmedAbdullah",
    phone: '0508337457',
    serv: 'cust115.oraxmobile.com'
  },
  {
    name: "WaqatWanasah",
    phone: '0546826778',
    serv: 'cust7.oraxcloudweb.com'
    // serv: 'cust116.oraxmobile.com'
  },
  {
    name: "AflakAlAsemah",
    phone: '0550988880',
    serv: 'cust117.oraxmobile.com'
  },
  {
    name: "AlAmaalWalenjaaz",
    phone: '0558184429',
    serv: 'cust118.oraxmobile.com'
  },
  {
    name: "MhalThamerMaki",
    phone: '0532362606',
    serv: 'cust119.oraxmobile.com'
  },
  {
    name: "blackChocolte",
    phone: '0534611644',
    serv: 'cust120.oraxmobile.com'
  },
  {
    name: "AlJentBlack",
    phone: '0595830711',
    serv: 'cust121.oraxmobile.com'
  },
  {
    name: "AsmaaAlbareqi",
    phone: '0562155946',
    serv: 'cust122.oraxmobile.com'
  },
  {
    name: "HamelAlWard",
    phone: '0533440243',
    serv: 'cust123.oraxmobile.com'
  },
  {
    name: "AbedahSanad",
    phone: '0542251724',
    serv: 'cust124.oraxmobile.com'
  },
  {
    name: "AzwaqanaLelmoqsarat",
    phone: '0555596861',
    serv: 'cust125.oraxmobile.com'
  },
  {
    name: "AlhaalAlmethali",
    phone: '0535599154',
    serv: 'cust126.oraxmobile.com'
  },
  {
    name: "MahtatAlarqanAlzahabia",
    phone: '00552388845',
    serv: 'cust127.oraxmobile.com'
  },
  {
    name: "SoltanZyaar",
    phone: '0510149517',
    serv: 'cust128.oraxmobile.com'
  },
  {
    name: "BreeqAlBonyaan",
    phone: '0569854085',
    serv: 'cust129.oraxmobile.com'
  },
  {
    name: "BashyerAyedh",
    phone: '0559268377',
    serv: 'cust130.oraxmobile.com'
  },
  {
    name: "RayanAliAlKahtani",
    phone: '05006655',
    serv: 'cust131.oraxmobile.com'
  },
  {
    name: "ZaidAbdullah",
    phone: '0550372394',
    serv: 'cust132.oraxmobile.com'
  },
  {
    name: "EbdaaAlTanmeia",
    phone: '0506582398',
    serv: 'cust133.oraxmobile.com'
  },
  {
    name: "SoltanaAlEnaab",
    phone: '0550419909',
    serv: 'cust134.oraxmobile.com'
  },
  {
    name: "AdwaaAlSanabel",
    phone: '0556663492',
    serv: 'cust135.oraxmobile.com'
  },
  {
    name: "ShiefAlMothedah",
    phone: '0555921216',
    serv: 'cust136.oraxmobile.com'
  },
  {
    name: "MakhratatKyanAlsammam",
    phone: '0576405631',
    serv: 'cust137.oraxmobile.com'
  },
  {
    name: "FakherWatan",
    phone: '0544624555',
    serv: 'cust138.oraxmobile.com'
  },
  {
    name: "EnaratAlbadyah",
    phone: '0533444725',
    serv: 'cust139.oraxmobile.com'
  },
  {
    name: "AlWardAlOola",
    phone: '0547373897',
    serv: 'cust140.oraxmobile.com'
  },
  {
    name: "AmeedAlbenaa",
    phone: '0502229904',
    serv: 'cust141.oraxmobile.com'
  },
  {
    name: "AaberAlgharbia",
    phone: '0545505066',
    serv: 'cust142.oraxmobile.com'
  },
  {
    name: "AlFareeqALshamali",
    phone: '0505804904',
    serv: 'cust143.oraxmobile.com'
  },
  {
    name: "DoratFonoonAlreem",
    phone: '0500710012',
    serv: 'cust144.oraxmobile.com'
  },
  {
    name: "BaderBnTalal",
    phone: '0564666451',
    serv: 'cust145.oraxmobile.com'
  },
  {
    name: "BaqatAlward",
    phone: '0500145733',
    serv: 'cust146.oraxmobile.com'
  },
  {
    name: "YaserBadah",
    phone: '0550481703',
    serv: 'cust147.oraxmobile.com'
  },
  {
    name: "NasserAsheq",
    phone: '0553523111',
    serv: 'cust148.oraxmobile.com'
  },
  {
    name: "AlEbteqaratAlkhashbia",
    phone: '0559113903',
    serv: 'cust149.oraxmobile.com'
  },
  {
    name: "AlOfeqAlmodee",
    phone: '0596162240',
    // serv: 'cust150.oraxmobile.com'
    serv: 'cust16.oraxcloudweb.com'
  },
  {
    name: "NajmatMozhela",
    phone: '0540606624',
    serv: 'cust151.oraxmobile.com'
  },
  {
    name: "AlbAwabaAlWaseah",
    phone: '0578804895',
    serv: 'cust152.oraxmobile.com'
  },
  {
    name: "RaqazAlkhaleeg",
    phone: '0555727870',
    serv: 'cust153.oraxmobile.com'
  },
  {
    name: "ZedGyangh",
    phone: '0537342427',
    serv: 'cust154.oraxmobile.com'
  },
  {
    name: "WeshahSoltana",
    phone: '0533317838',
    serv: 'cust155.oraxmobile.com'
  },
  {
    name: "AsaadMohammed",
    phone: '0509485077',
    serv: 'cust156.oraxmobile.com'
  },
  {
    name: "TaqAlSawrma",
    phone: '0000530666766',
    serv: 'cust157.oraxmobile.com'
  },
  {
    name: "MashelAlmaha",
    phone: '0536539129',
    serv: 'cust158.oraxmobile.com'
  },
  {
    name: "ALhayaInterprise",
    phone: '08264911121',
    serv: 'cust159.oraxmobile.com'
  },
  {
    name: "QowatAlbena",
    phone: '0503908822',
    serv: 'cust160.oraxmobile.com'
  },
  {
    name: "HroofAljeel",
    phone: '0503499161',
    serv: 'cust161.oraxmobile.com'
  },
  {
    name: "ShabkatAlgheza",
    phone: '0597527392',
    serv: 'cust162.oraxmobile.com'
  },
  {
    name: "AlmasahAlfaredah",
    phone: '0566964689',
    serv: 'cust164.oraxmobile.com'
  },
  {
    name: "MohammedHadiHakmi",
    phone: '0534215861',
    serv: 'cust165.oraxmobile.com'
  },
  {
    name: "lamaAlkhalegiah",
    phone: '0566082251',
    serv: 'cust163.oraxmobile.com'
  },
  {
    name: "FakherAlemtyaz",
    phone: '0500777245',
    serv: 'cust166.oraxmobile.com'
  },
  {
    name: "AdelDakheel",
    phone: '0557404369',
    serv: 'cust167.oraxmobile.com'
  },
  {
    name: "LamatNeqal",
    phone: '0504898980',
    serv: 'cust168.oraxmobile.com'
  },
  {
    name: "NaqhatAlfakhamah",
    phone: '0505739982',
    serv: 'cust169.oraxmobile.com'
  },
  {
    name: "AbraaqNofaa",
    phone: '0559602580',
    serv: 'cust170.oraxmobile.com'
  },
  {
    name: "AbdullahYahyaMofreq",
    phone: '0534545589',
    serv: 'cust111.oraxcloud.com'
  },
  {
    name: "AmwagAlnomah",
    phone: '0503550068',
    serv: 'cust112.oraxcloud.com'
  },

  {
    name: "ByeetAlMokhtarCompany",
    phone: '0500910539',
    serv: 'cust113.oraxcloud.com'
  },
  {
    name: "newCustTow",
    phone: '05552111',
    serv: 'cust114.oraxcloud.com'
  },
  {
    name: "RowatAlyasmeen",
    phone: '0553358155',
    serv: 'cust115.oraxcloud.com'
  },
  {
    name: "SetaAsherDarjah",
    phone: '0532749129',
    serv: 'cust116.oraxcloud.com'
  },
  {
    name: "AdwaAlmotwaset",
    phone: '0506050286',
    serv: 'cust117.oraxcloud.com'
  },
  {
    name: "NakhlatAlzahbee",
    phone: '0556056097',
    serv: 'cust118.oraxcloud.com'
  },
  {
    name: "KhotootAlqahwa",
    phone: '0564175905',
    serv: 'cust119.oraxcloud.com'
  },
  {
    name: "AdwaAlAneeq",
    phone: '0537163018',
    serv: 'cust120.oraxcloud.com'
  },
  {
    name: "Alhamror",
    phone: '055690',
    serv: 'cust121.oraxcloud.com'
  },
  {
    name: "YasserBnJaman",
    phone: '0553003929',
    serv: 'cust122.oraxcloud.com'
  },
  {
    name: "NasmatAlshraa",
    phone: '00560480084',
    serv: 'cust123.oraxcloud.com'
  },
  {
    name: "RwadAlmalaeb",
    phone: '0550777222',
    serv: 'cust124.oraxcloud.com'
  },
  {
    name: "LethahWaaqther",
    phone: '0507981274',
    serv: 'cust125.oraxcloud.com'
  },
  {
    name: "DamerTrading",
    phone: '0560696196',
    serv: 'cust126.oraxcloud.com'
  },
  {
    name: "YousifHammed",
    phone: '0500352160',
    serv: 'cust127.oraxcloud.com'
  },
  {
    name: "YazeedYousif",
    phone: '00500352160',
    serv: 'cust128.oraxcloud.com'
  },
  {
    name: "NokhbatAlmashahair",
    phone: '0530513760',
    serv: 'cust129.oraxcloud.com'
  },
  {
    name: "EmaarAlestwaeyah",
    phone: '00594448592',
    serv: 'cust130.oraxcloud.com'
  },
  {
    name: "lamsaatAlsharq",
    phone: '0555957686',
    serv: 'cust131.oraxcloud.com'
  },
  {
    name: "MahamesWaMtahenAlMadenah",
    phone: '0531151145',
    serv: 'cust2.oraxcloudweb.com'
    // serv: 'cust132.oraxcloud.com'
  },
  {
    name: "AsaanTradingEst",
    phone: '0504118100',
    serv: 'cust133.oraxcloud.com'
  },
  {
    name: "RwafedDobi",
    phone: '00530530938',
    serv: 'cust134.oraxcloud.com'
  },
  {
    name: "RyooqAlSadah",
    phone: '0599591626',
    serv: 'cust135.oraxcloud.com'
  },
  {
    name: "TsameemAlHarem",
    phone: '0541874793',
    // serv: 'cust136.oraxcloud.com'
    serv: 'cust17.oraxcloudweb.com'
  },
  {
    name: "AlNorasAlsareeTow",
    phone: '0050108822',
    // serv: 'cust137.oraxcloud.com'
    serv: 'cust19.oraxcloudweb.com'
  },
  {
    name: "RoqenAlOtoor",
    phone: '0580004655',
    serv: 'cust138.oraxcloud.com'
  },
  {
    name: "AlRoqenAlAjmal",
    phone: '0558748564',
    serv: 'cust139.oraxcloud.com'
  },
  {
    name: "RyadhDobo",
    phone: '0565905789',
    serv: 'cust140.oraxcloud.com'
  },
  {
    name: "ValcoonMasheri",
    phone: '0562387559',
    serv: 'cust141.oraxcloud.com'
  },
  {
    name: "SarahMohammedYousif",
    phone: '0555252836',
    serv: 'cust142.oraxcloud.com'
  },
  {
    name: "MasarAlthamer",
    phone: '0550589851',
    serv: 'cust143.oraxcloud.com'
  },
  {
    name: "YallowFarm",
    phone: '0540865708',
    serv: 'cust144.oraxcloud.com'
  },
  {
    name: "AlmoredAleqtesadi",
    phone: '0592287170',
    serv: 'cust145.oraxcloud.com'
  },
  {
    name: "TobelAlbyan",
    phone: '0553967964',
    serv: 'cust146.oraxcloud.com'
  },
  {
    name: "WahgAlhadaf",
    phone: '0531834119',
    serv: 'cust147.oraxcloud.com'
  },
  {
    name: "demomohammed",
    phone: '0559193266',
    serv: 'cust148.oraxcloud.com'
  },
  {
    name: "AredAlAmaal",
    phone: '0059902612',
    serv: 'cust149.oraxcloud.com'
  },
  {
    name: "SahamBlas",
    phone: '0506999660',
    serv: 'cust150.oraxcloud.com'
  },
  {
    name: "AflakAlfolazTow",
    phone: '0507927517',
    serv: 'cust151.oraxcloud.com'
  },
  {
    name: "FattahAlreef",
    phone: '0555570873',
    serv: 'cust3.oraxcloudweb.com'
    // serv: 'cust152.oraxcloud.com'
  },
  {
    name: "JomanahAlDonia",
    phone: '0563580696',
    serv: 'cust153.oraxcloud.com'
  },
  {
    name: "TairAlNakheel",
    phone: '0562261386',
    serv: 'cust154.oraxcloud.com'
  },
  {
    name: "MabkhratAlOood",
    phone: '0582546554',
    serv: 'cust155.oraxcloud.com'
  },
  {
    name: "QatyfAlQeef",
    phone: '0509058590',
    serv: 'cust156.oraxcloud.com'
  },
  {
    name: "SanadNaher",
    phone: '0541112557',
    serv: 'cust157.oraxcloud.com'
  },
  {
    name: "EsmailFattah2",
    phone: '0054418566',
    serv: 'cust158.oraxcloud.com'
  },
  {
    name: "JoodAlRasam",
    phone: '0554346030',
    serv: 'cust159.oraxcloud.com'
  },
  {
    name: "AlSorahWaEtqaan",
    phone: '0547090605',
    serv: 'cust160.oraxcloud.com'
  },
  {
    name: "MashahedAlRagamah",
    phone: '0506220710',
    serv: 'cust161.oraxcloud.com'
  },
  {
    name: "SharehatAlmonfez",
    phone: '0546777708',
    serv: 'cust162.oraxcloud.com'
  },
  {
    name: "SowfatAlBoraq",
    phone: '0500076322',
    serv: 'cust163.oraxcloud.com'
  },
  {
    name: "WarshatAbdullahAziz",
    phone: '0566635541',
    serv: 'cust164.oraxcloud.com'
  },
  {
    name: "MadaenAlAdad",
    phone: '0552029986',
    serv: 'cust165.oraxcloud.com'
  },
  {
    name: "DanatAlkhobar",
    phone: '0530620180',
    serv: 'cust166.oraxcloud.com'
  },
  {
    name: "AlRasamAljadeed",
    phone: '0530005526',
    serv: 'cust167.oraxcloud.com'
  },
  {
    name: "njoomSodMareb",
    phone: '0580503103',
    serv: 'cust168.oraxcloud.com'
  },
  {
    name: "BofyatZamzam",
    phone: '0591882179',
    serv: 'cust169.oraxcloud.com'
  },
  {
    name: "TalaeaAlKookh",
    phone: '0509495250',
    serv: 'cust170.oraxcloud.com'
  },
  {
    name: "AlArabiaForm",
    phone: '0533330035',
    serv: 'cust171.oraxcloud.com'
  },
  {
    name: "AlArabiaForm",
    phone: '0533330035',
    serv: 'cust171.oraxcloud.com'
  },
  {
    name: "DowagenAlWalemah",
    phone: '0540615777',
    serv: 'cust172.oraxcloud.com'
  },
  {
    name: "AlromoozAlMamaryah",
    phone: '0563662932',
    serv: 'cust173.oraxcloud.com'
  },
  {
    name: "MacTeknykal",
    phone: '0570977999',
    serv: 'cust174.oraxcloud.com'
  },
  {
    name: "FeqrahWaMaarefah",
    phone: '05007371061',
    serv: 'cust175.oraxcloud.com'
  },
  {
    name: "RwadAlJadeed",
    phone: '0507746050',
    serv: 'cust176.oraxcloud.com'
  },
  {
    name: "KhaledAlEnzi",
    phone: '0543333',
    serv: 'cust177.oraxcloud.com'
  },
  {
    name: "DemoTalalRest",
    phone: '11115555',
    serv: 'cust178.oraxcloud.com'
  },
  {
    name: "DemoMohammedRest",
    phone: '222333444',
    serv: 'cust179.oraxcloud.com'
  },
  {
    name: "AliSolimanAoeed",
    phone: '0555992793',
    serv: 'cust180.oraxcloud.com'
  },
  {
    name: "mazagalaan",
    phone: '0557546587',
    serv: 'cust6.oraxcloudweb.com'
    // serv: 'cust181.oraxcloud.com'
  },
  {
    name: "AwaelAlbroog",
    phone: '0510707288',
    serv: 'cust182.oraxcloud.com'
  },
  {
    name: "SholatAlEtqaan",
    phone: '0542013620',
    serv: 'cust183.oraxcloud.com'
  },
  {
    name: "SholatAlEtqaan",
    phone: '0542013620',
    serv: 'cust184.oraxcloud.com'
  },
  {
    name: "BarqAlRaheeb",
    phone: '0550852823',
    serv: 'cust185.oraxcloud.com'
  },
  {
    name: "MwarefAlOrorah",
    phone: '501266900',
    serv: 'cust186.oraxcloud.com'
  },
  {
    name: "HossainAllSwedan",
    phone: '0504919955',
    serv: 'cust187.oraxcloud.com'
  },
  {
    name: "AlkhoderahEst",
    phone: '0555536193',
    serv: 'cust188.oraxcloud.com'
  },
  {
    name: "AltoroqAlSharqia",
    phone: '055799966',
    serv: 'cust189.oraxcloud.com'
  },
  {
    name: "QabdatAsaqer",
    phone: '0559960505',
    serv: 'cust190.oraxcloud.com'
  },
  {
    name: "AlnorasAccount",
    phone: '0051088',
    serv: 'cust191.oraxcloud.com'
  },
  {
    name: "ByeetAlZafraan",
    phone: '00580004655',
    serv: 'cust192.oraxcloud.com'
  },
  {
    name: "NabaaAlEtedal",
    phone: '0596000526',
    serv: 'cust193.oraxcloud.com'
  },
  {
    name: "AlBeetAlSabee",
    phone: '0559762207',
    serv: 'cust194.oraxcloud.com'
  },
  {
    name: "KhadeqaMansoor",
    phone: '0545826668',
    serv: 'cust195.oraxcloud.com'
  },
  // {
  //   name: "NabaaAlEtedal",
  //   phone: '0596000526',
  //   serv: 'cust196.oraxcloud.com'
  // },
  {
    name: "AbraagAlsharq",
    phone: '0541005270',
    serv: 'cust197.oraxcloud.com'
  },
  {
    name: "AsayelAlMahrah",
    phone: '0542005561',
    serv: 'cust198.oraxcloud.com'
  },
  {
    name: "AlemAlJehaz",
    phone: '0558630716',
    serv: 'cust199.oraxcloud.com'
  },
  {
    name: "LyliAlhgarbia2025",
    phone: '000530890855',
    serv: 'cust200.oraxcloud.com'
  },
  {
    name: "byaan2025",
    phone: '509515838',
    serv: 'cust201.oraxcloud.com'
  },
  {
    name: "enjazat2025",
    phone: '55482',
    serv: 'cust202.oraxcloud.com'
  },
  {
    name: "RahatAltaqmeel",
    phone: '0532310818',
    serv: 'cust203.oraxcloud.com'
  },
  {
    name: "LaylaMohammed",
    phone: '0538852014',
    serv: 'cust204.oraxcloud.com'
  },
  {
    name: "TyarAlbenaa",
    phone: '0539848010',
    serv: 'cust205.oraxcloud.com'
  },
  {
    name: "SahamAlSorah",
    phone: '0530415683',
    serv: 'cust206.oraxcloud.com'
  },
  {
    name: "WatterAlEees",
    phone: '0593946070',
    serv: 'cust207.oraxcloud.com'
  },
  {
    name: "Broooblas",
    phone: '0504298506',
    serv: 'cust208.oraxcloud.com'
  },
  {
    name: "AlZamanAlQadeem",
    phone: '0507079844',
    serv: 'cust209.oraxcloud.com'
  },
  {
    name: "AlOwaedAlAleyah",
    phone: '0562024331',
    serv: 'cust210.oraxcloud.com'
  },
  {
    name: "AlmeladAlFdal",
    phone: '0506306983',
    serv: 'cust211.oraxcloud.com'
  },
  {
    name: "WahgAlPhakher",
    phone: '0556836099',
    serv: 'cust212.oraxcloud.com'
  },
  {
    name: "BaderBnTalaltow",
    phone: '564666451',
    serv: 'cust213.oraxcloud.com'
  },
  {
    name: "ALRawedAlfakhmah",
    phone: '0553119986',
    serv: 'cust214.oraxcloud.com'
  },
  {
    name: "AmelAlAjyal",
    phone: '0541990293',
    serv: 'cust8.oraxcloudweb.com'
    // serv: 'cust215.oraxcloud.com'
  },
  {
    name: "AlByreqAlZahbia",
    phone: '0505381293',
    serv: 'cust216.oraxcloud.com'
  },
  {
    name: "AlAsnafAlAselah",
    phone: '0590471013',
    serv: 'cust217.oraxcloud.com'
  },
  {
    name: "NafezatAlMeftah",
    phone: '0530802333',
    serv: 'cust218.oraxcloud.com'
  },
  {
    name: "AlSehahAlMotamadah",
    phone: '0597506786',
    serv: 'cust219.oraxcloud.com'
  },
  {
    name: "NafezatAlmetahtow",
    phone: '05308023',
    serv: 'cust220.oraxcloud.com'
  },
  {
    name: "MahtatAbearAli",
    phone: '0551152220',
    serv: 'cust221.oraxcloud.com'
  },
  {
    name: "SafaAlTaqaa",
    phone: '0503163458',
    serv: 'cust222.oraxcloud.com'
  },
  {
    name: "AlHaqaaqCompany",
    phone: '0550906556',
    serv: 'cust223.oraxcloud.com'
  },
  {
    name: "naqlaaNahed",
    phone: '0537686472',
    serv: 'cust224.oraxcloud.com'
  },
  {
    name: "NafsAlnakhlah2025",
    phone: '51003910',
    serv: 'cust225.oraxcloud.com'
  },
  {
    name: "QahwatAlReef",
    phone: '0583199750',
    serv: 'cust226.oraxcloud.com'
  },
  {
    name: "AdwaaRoqenAlkyef",
    phone: '0530889571',
    serv: 'cust227.oraxcloud.com'
  },
  {
    name: "JadeedAlMalaeb",
    phone: '0502023328',
    serv: 'cust10.oraxcloudweb.com'
    // serv: 'cust228.oraxcloud.com'
  },
  {
    name: "SaidHammedAlNahdi",
    phone: '0504683229',
    serv: 'cust229.oraxcloud.com'
  },
  {
    name: "AstohAlJeel",
    phone: '0542255418',
    serv: 'cust230.oraxcloud.com'
  },
  {
    name: "PrinceAbdulrahman",
    phone: '0562222574',
    serv: 'cust231.oraxcloud.com'
  },
  {
    name: "NebrasAlAtlal",
    phone: '0507963811',
    serv: 'cust232.oraxcloud.com'
  },
  {
    name: "BayooDeramateq",
    phone: '0552242723',
    serv: 'cust233.oraxcloud.com'
  },
  {
    name: "MahlatAlMoghles",
    phone: '779964647',
    serv: 'cust234.oraxcloud.com'
  },
  {
    name: "ZahratLora",
    phone: '0533495191',
    serv: 'cust235.oraxcloud.com'
  },
  {
    name: "NakheelAlBawadi",
    phone: '0545553045',
    serv: 'cust236.oraxcloud.com'
  },
  {
    name: "DeefAutow",
    phone: '0533858835',
    serv: 'cust237.oraxcloud.com'
  },
  {
    name: "SaryaRafeef",
    phone: '0569585169',
    serv: 'cust238.oraxcloud.com'
  },
  {
    name: "AzabAlseef",
    phone: '0509264069',
    serv: 'cust239.oraxcloud.com'
  },
  {
    name: "NewCustomersOne",
    phone: '0100200300',
    serv: 'cust240.oraxcloud.com'
  },
  {
    name: "NewCuatomersTow",
    phone: '0963963',
    serv: 'cust171.oraxmobile.com'
  },
  {
    name: "NewCustomersThree",
    phone: '0852852',
    serv: 'cust172.oraxmobile.com'
  },
  {
    name: "NewCustomersFour",
    phone: '0103020',
    serv: 'cust173.oraxmobile.com'
  },
  {
    name: "RwaeeNjoomAlsharqia",
    phone: '0503908649',
    serv: 'cust174.oraxmobile.com'
  },
  {
    name: "lamsatAljalbia",
    phone: '0559922797',
    serv: 'cust175.oraxmobile.com'
  },
  {
    name: "masnaaAlhyqal",
    phone: '0569095041',
    serv: 'cust176.oraxmobile.com'
  },
  {
    name: "SafrahAyedh",
    phone: '0562492902',
    serv: 'cust177.oraxmobile.com'
  },
  {
    name: "MasnaaQoon",
    phone: '0565666334',
    serv: 'cust178.oraxmobile.com'
  },
  {
    name: "AbsherClick",
    phone: '0536510706',
    serv: 'cust179.oraxmobile.com'
  },
  {
    name: "AkhtobootAlEmlaq",
    phone: '0538190350',
    serv: 'cust180.oraxmobile.com'
  },
  {
    name: "SwarAlReyadah",
    phone: '0537887824',
    serv: 'cust181.oraxmobile.com'
  },
  {
    name: "AbraagAlHadaf",
    phone: '0504561361',
    serv: 'cust182.oraxmobile.com'
  },
  {
    name: "RoqenAlAmal",
    phone: '0536626631',
    serv: 'app11.oraxcloud1.com'
    // serv: 'cust183.oraxmobile.com'
  },
  {
    name: "AbdulmajeedFwaz",
    phone: '0561673603',
    serv: 'cust184.oraxmobile.com'
  },
  {
    name: "SaryaAlrokham",
    phone: '0533055510',
    serv: 'cust185.oraxmobile.com'
  },
  {
    name: "FeqerWaebdaa",
    phone: '0575478542',
    serv: 'cust186.oraxmobile.com'
  },
  {
    name: "RwaeaAlKalas",
    phone: '0566681770',
    serv: 'cust187.oraxmobile.com'
  },
  {
    name: "RwaeaAlKalas",
    phone: '0566681770',
    serv: 'cust187.oraxmobile.com'
  },
  {
    name: "LethahDanah",
    phone: '0559048600',
    serv: 'cust188.oraxmobile.com'
  },
  {
    name: "KalidMohammedAlAjmi",
    phone: '0504291531',
    serv: 'cust189.oraxmobile.com'
  },
  {
    name: "ArwaMohammed",
    phone: '0057173034',
    serv: 'cust190.oraxmobile.com'
  },
  {
    name: "SadeqAlTamyoz",
    phone: '0535089684',
    serv: 'cust191.oraxmobile.com'
  },
  {
    name: "QwatZenk",
    phone: '0546938185',
    serv: 'cust192.oraxmobile.com'
  },
  {
    name: "TafratAlbomyaan",
    phone: '0556552122',
    serv: 'cust193.oraxmobile.com'
  },
  {
    name: "NorahAbeedMady",
    phone: '0554804741',
    serv: 'cust194.oraxmobile.com'
  },
  {
    name: "AlemAlSorahCompany",
    phone: '0536329366',
    serv: 'cust195.oraxmobile.com'
  },
  {
    name: "AhmedEsaaAlhasnat",
    phone: '0553144457',
    serv: 'cust196.oraxmobile.com'
  },
  {
    name: "MohammedMosferAlAmer",
    phone: '0503872717',
    serv: 'cust197.oraxmobile.com'
  },
  {
    name: "NasmatLatefah",
    phone: '0551085867',
    serv: 'cust198.oraxmobile.com'
  },
  {
    name: "MontagatAlRafaa",
    phone: '0542341049',
    serv: 'cust199.oraxmobile.com'
  },
  {
    name: "MatabeeAjyad",
    phone: '0569558080',
    serv: 'cust200.oraxmobile.com'
  },
  {
    name: "Bromessing",
    phone: '0598507072',
    serv: 'cust201.oraxmobile.com'
  },
  {
    name: "Bromessing",
    phone: '0559868543',
    serv: 'cust202.oraxmobile.com'
  },
  {
    name: "MayzoonEtchCompany",
    phone: '0500061668',
    serv: 'cust203.oraxmobile.com'
  },
  {
    name: "MahtatReyadMohammed",
    phone: '0558556324',
    serv: 'cust204.oraxmobile.com'
  },
  {
    name: "TawoonBoorLeltabreeed",
    phone: '0593655225',
    serv: 'cust205.oraxmobile.com'
  },
  {
    name: "AlBoshraaAlraedah",
    phone: '0557126646',
    serv: 'cust206.oraxmobile.com'
  },
  {
    name: "BawerGeneryshen",
    phone: '0559765999',
    serv: 'cust207.oraxmobile.com'
  },
  {
    name: "MahalAlansegah",
    phone: '0580901008',
    serv: 'cust208.oraxmobile.com'
  },
  {
    name: "NoofMohammedEst",
    phone: '580901008',
    serv: 'cust209.oraxmobile.com'
  },
  {
    name: "JanoobAlhaqah",
    phone: '0551556627',
    serv: 'cust210.oraxmobile.com'
  },
  {
    name: "Ahmedhosainaothman",
    phone: '0549484371',
    serv: 'cust211.oraxmobile.com'
  },
  {
    name: "QwatAltareek",
    phone: '0501846681',
    serv: 'cust212.oraxmobile.com'
  },
  {
    name: "hazmalmasharee",
    phone: '0582713694',
    serv: 'cust213.oraxmobile.com'
  },
  {
    name: "RoqenLenaa",
    phone: '0532906705',
    serv: 'cust214.oraxmobile.com'
  },
  {
    name: "mahalghadqAlwared",
    phone: '0558362820',
    serv: 'cust215.oraxmobile.com'
  },
  {
    name: "NasmatLatefahTow",
    phone: '0564285998',
    serv: 'cust216.oraxmobile.com'
  },
  {
    name: "AryaafAljodah",
    phone: '0569992108',
    serv: 'cust217.oraxmobile.com'
  },
  {
    name: "EmEmWyCompany",
    phone: '0598690208',
    serv: 'cust218.oraxmobile.com'
  },
  {
    name: "alareqahalkhasah",
    phone: '0508413323',
    serv: 'cust219.oraxmobile.com'
  },
  {
    name: "zaadAlbehar",
    phone: '0558664159',
    serv: 'cust220.oraxmobile.com'
  },
  {
    name: "EsnadAltaqadom",
    phone: '0551222393',
    serv: 'cust221.oraxmobile.com'
  },
  {
    name: "MataamAlhadeeth",
    phone: '0538014532',
    serv: 'cust222.oraxmobile.com'
  },
  {
    name: "KyanAlmohtarefon",
    phone: '0539949880',
    serv: 'cust223.oraxmobile.com'
  },
  {
    name: "yaslambander",
    phone: '0569116230',
    serv: 'cust224.oraxmobile.com'
  },
  {
    name: "relensentgreted",
    phone: '0555440191',
    serv: 'cust225.oraxmobile.com'
  },
  {
    name: "AlberensTrading",
    phone: '0506795944',
    serv: 'cust226.oraxmobile.com'
  },
  {
    name: "MashareeAmwag",
    phone: '0552813471',
    serv: 'cust227.oraxmobile.com'
  },
  {
    name: "hagerWaMaged",
    phone: '0894881454',
    serv: 'cust228.oraxmobile.com'
  },
  {
    name: "DalatAldeef",
    phone: '0510368617',
    serv: 'cust229.oraxmobile.com'
  },
  {
    name: "RwasiAlshamekhah",
    phone: '0559048803',
    serv: 'cust230.oraxmobile.com'
  },
  {
    name: "ZelalWarfahCompany",
    phone: '0505306244',
    serv: 'cust231.oraxmobile.com'
  },
  {
    name: "SharartAltamayooz",
    phone: '0566352552',
    serv: 'cust232.oraxmobile.com'
  },
  {
    name: "QematAlbyraq",
    phone: '0505263182',
    serv: 'cust233.oraxmobile.com'
  },
  {
    name: "ModeeZeeb",
    phone: '0577080575',
    serv: 'cust234.oraxmobile.com'
  },
  {
    name: "RahaatAltajmeel",
    phone: '00532310818',
    serv: 'cust235.oraxmobile.com'
  },
  {
    name: "beketblack",
    phone: '0531061016',
    serv: 'cust26.oraxcloudweb.com'
  },
  {
    name: "qadatalelaan",
    phone: '0508951086',
    serv: 'cust27.oraxcloudweb.com'
  },
  {
    name: "dabaihamjd2025",
    phone: '000556029890',
    serv: 'app1.oraxcloud1.com'
  },
  {
    name: "promisingantr",
    phone: '0537905021',
    serv: 'app2.oraxcloud1.com'
  },
  {
    name: "nkahtfrawelh2025",
    phone: '0576449586',
    serv: 'app3.oraxcloud1.com'
  },
  {
    name: "tearalqhoa",
    phone: '0567855990',
    serv: 'app4.oraxcloud1.com'
  },
  {
    name: "bwabtalmosthmer",
    phone: '0556807423',
    serv: 'app5.oraxcloud1.com'
  },
  {
    name: "amwagalref",
    phone: '00552813471',
    serv: 'app6.oraxcloud1.com'
  },
  {
    name: "shebanalrayda",
    phone: '0575555140',
    serv: 'cust30.oraxcloudweb.com'
  },
  {
    name: "ronqaga",
    phone: '0554837368',
    serv: 'app8.oraxcloud1.com'
  },
  {
    name: "tmwenatmrem",
    phone: '0566993414',
    serv: 'app9.oraxcloud1.com'
  },
  {
    name: "thamermaji",
    phone: '00532362606',
    serv: 'app10.oraxcloud1.com'
  },
  {
    name: "osamaomar",
    phone: '0559020830',
    serv: 'app12.oraxcloud1.com'
  },
  {
    name: "taqtkom",
    phone: '0500101324',
    serv: 'app13.oraxcloud1.com'
  },
  {
    name: "halaAlfakhera2026",
    phone: '00553616275',
    serv: 'app14.oraxcloud1.com'
  },
  // {
  //   name: "sheldclass",
  //   phone: '00562398551',
  //   serv: 'app15.oraxcloud1.com'
  // },
  {
    name: "saadalhgamdi",
    phone: '0554746129',
    serv: 'cust28.oraxcloudweb.com'
  },
  {
    name: "bofyat",
    phone: '02580258',
    serv: 'cust29.oraxcloudweb.com'
  },
  {
    name: "AtlasAlmosqbal",
    phone: '0533566691',
    serv: 'cust31.oraxcloudweb.com'
  },
  {
    name: "SyamEleet",
    phone: '0510681055',
    serv: 'cust33.oraxcloudweb.com'
  },
  {
    name: "nazratakAlelyah",
    phone: '0501113058',
    serv: 'cust34.oraxcloudweb.com'
  },
  {
    name: "smaaliz",
    phone: '0566675448',
    serv: 'cust35.oraxcloudweb.com'
  },
  {
    name: "AlghyoomAlsodaa",
    phone: '0551655777',
    serv: 'cust36.oraxcloudweb.com'
  },

  {
    name: "AqedAltamyooz",
    phone: '0535772765',
    serv: 'cust37.oraxcloudweb.com'
  },
  {
    name: "DalyooEst",
    phone: '00551655777',
    serv: 'cust38.oraxcloudweb.com'
  },
  {
    name: "SbarkAuoto",
    phone: '0500876083',
    serv: 'cust39.oraxcloudweb.com'
  },
  {
    name: "sheldclass",
    phone: '00562398551',
    serv: 'cust40.oraxcloudweb.com'
  },
  {
    name: "MariyahEbrahim",
    phone: '0551661313',
    serv: 'app15.oraxcloud1.com'
  },
  {
    name: "seragomar",
    phone: '0506677764',
    serv: 'cust41.oraxcloudweb.com'
  },
  {
    name: "zhoralasar",
    phone: '0559880951',
    serv: 'cust42.oraxcloudweb.com'
  },
  {
    name: "LtefaAlzahbia",
    phone: '0555948925',
    serv: 'app16.oraxcloud1.com'
  },
  {
    name: "banollmlabsym",
    phone: '738295305',
    serv: 'app17.oraxcloud1.com'
  },
  {
    name: "Roqnalfakhama",
    phone: '0505617951',
    serv: 'cust43.oraxcloudweb.com'
  },
  {
    name: "aldamanalfidiy",
    phone: '0536511539',
    serv: 'cust44.oraxcloudweb.com'
  },
  {
    name: "matbakhialasili",
    phone: '0506405558',
    serv: 'app18.oraxcloud1.com'
  },
  {
    name: "trana",
    phone: "0533123364",
    serv: "app19.oraxcloud1.com",
  }, 
  {
    name: "suhbalkhayr",  
    phone: "00532675513",
    serv: "app20.oraxcloud1.com",
  },
  {
    name: "promisingantrGfan",
    phone: "0504994333",
    serv: "app21.oraxcloud1.com",
  },
  {
    name: "fakhamatalraaqi",
    phone: "0592377641",
    serv: "app22.oraxcloud1.com",
  },
  {
    name: "MwarefAlOrorahL",
    phone: '0501266900',
    serv: "app23.oraxcloud1.com",
  },
  {
    name: "rawasialtawzie",
    phone: '0539992792',
    serv: "app24.oraxcloud1.com",
  },
  {
    name: "asasaljud",
    phone: '0565012599',
    serv: "app25.oraxcloud1.com",
  },
  {
    name: "RwaeeRomans",
    phone: '0595627471',
    serv: 'cust45.oraxcloudweb.com'
  },
  {
    name: "kunuzalkhalij",
    phone: '0580069229',
    serv: 'cust46.oraxcloudweb.com'
  },
  {
    name: "samiRuibah",
    phone: '0556604965',
    serv: "app26.oraxcloud1.com",
  },
  {
    name: "zawiataljawda",
    phone: '0502784485',
    serv: 'cust47.oraxcloudweb.com'
  },
  {
    name: "MalhamatAlEgel",
    phone: '0533177918',
    serv: 'cust48.oraxcloudweb.com'
  },
  {
    name: "khaderahMohammed",
    phone: '0501030835',
    serv: 'cust49.oraxcloudweb.com'
  },
  {
    name: "nazratjayidacar",
    phone: '0550584109',
    serv: "app27.oraxcloud1.com",
  },
  {
    name: "oudalqurashiu",
    phone: '0508120097',
    // serv: "app28.oraxcloud1.com",
    serv: 'cust55.oraxcloudweb.com'
  },
  {
    name: "hesaheatiq",
    phone: '0547462123',
    serv: "app30.oraxcloud1.com",
  },
  {
    name: "ShamsAltaswq",
    phone: '0510452331',
    serv: 'cust50.oraxcloudweb.com'
  },
  {
    name: "HappyRose",
    phone: '0545145144',
    serv: "cust51.oraxcloudweb.com",
    // serv: "app29.oraxcloud1.com",
  },
  {
    name: "mashealbinsinaat",
    phone: '0552269562',
    serv: 'cust52.oraxcloudweb.com'
  },
  {
    name: "FalaqAltwreed",
    phone: '055590',
    serv: 'cust53.oraxcloudweb.com'
  },
  {
    name: "madaraleawayid",
    phone: '0502859981',
    serv: 'cust54.oraxcloudweb.com'
  },
  {
    name: "masaalamran",
    phone: '0566867027',
    serv: 'cust56.oraxcloudweb.com'
  },
  {
    name: "tayfalmuhtarifin",
    phone: '0507500892',
    serv: 'cust57.oraxcloudweb.com'
  },
  {
    name: "phoneLink",
    phone: '0555496819',
    serv: "app31.oraxcloud1.com",
  },
  {
    name: "Roqnopen",
    phone: '0535652716',
    serv: 'cust58.oraxcloudweb.com'
  },
  {
    name: "HamsAltasameem",
    phone: '00541874793',
    serv: 'cust59.oraxcloudweb.com'
  },
  {
    name: "naserSaudalharbi",
    phone: '0541455266',
    serv: 'cust60.oraxcloudweb.com'
  },
  {
    name: "sadaAlrabee",
    phone: '0568337011',
    serv: 'cust61.oraxcloudweb.com'
  },
  {
    name: "monaAhmedalghtani",
    phone: '0538113342',
    serv: 'cust62.oraxcloudweb.com'
  },
  {
    name: "NesfAlqamer",
    phone: '0566850321',
    serv: "app32.oraxcloud1.com",
  },
  {
    name: "MahwarAlAqar",
    phone: '0508374577',
    serv: 'cust63.oraxcloudweb.com'
  },
  {
    name: "AdelAlbena",
    phone: '0500003586',
    serv: 'cust64.oraxcloudweb.com'
  },
  {
    name: "diqatalwajiha",
    phone: '0598869693',
    // serv: 'cust236.oraxmobile.com'
    serv: "app33.oraxcloud1.com",
  },
  {
    name: "Taqtqoom2026",
    phone: '00500101324',
    serv: "app35.oraxcloud1.com",
  },
  {
    name: "themalsanaa",
    phone: '0538670480',
    serv: 'cust65.oraxcloudweb.com'
  },
  {
    name: "syaghatef",
    phone: '0567985235',
    serv: 'cust66.oraxcloudweb.com'
  },
  {
    name: "alemegel",
    phone: '0580702846',
    serv: 'cust67.oraxcloudweb.com'
  },
  {
    name: "almutahidualmutamayiza",
    phone: '0538645110',
    serv: "app36.oraxcloud1.com",
  },
];

const sto = locRem,
  Rept = locRept,
  wsto = locSto,
  premiA = locPremiA,
  permiCuCo = locpermiCuCo,
  premiScr = locPremiScr;

export { insh, sto, wsto, premiA, permiCuCo, premiScr, Rept, cloudAPIs };